// AUTO-STRUCTURED locale file. Keys mirror en.ts exactly; missing keys fall back
// to English (see src/i18n/index.ts). Placeholders use {name} interpolation.
export default {
 modelAuthorization: {
  "title": "连接 ChatGPT",
  "description": "使用你的 ChatGPT 账号运行个人云端任务。",
  "name": "连接名称",
  "enterCode": "在 ChatGPT 授权页面输入以下代码：",
  "openProvider": "打开 ChatGPT 授权页面",
  "enableDevice": "请先在 ChatGPT 安全设置中启用设备代码登录。在授权页面完成登录后，这里会自动检查结果。",
  "chooseModels": "已连接。关闭此窗口，浏览实时模型目录并选择要使用的模型。",
  "cancel": "取消授权",
  "retry": "重新检查",
  "reauthorize": "重新授权",
  "done": "完成",
  "connect": "连接 ChatGPT",
  "failed": "授权失败，请重试。",
  "state": {
    "pending": "等待授权",
    "ready": "已连接",
    "expired": "授权代码已过期，请重新开始。",
    "requires_reauth": "需要授权"
  }
},
  cloudRemoteInspector: {
    noModels: "此设备没有可用模型。请在设备端配置提供方，或添加可用的个人云端模型。",
    modelSettings: "模型设置",
    fullPreview: "这里展示相对于目标分支的全部改动，包括已提交和未提交的内容。仅交付你勾选的文件。",
    "createDraft": "创建草稿 Pull request",
    "deliveryUpgrade": "升级此设备上的 jcode 后，可交付已审阅的改动。",
    "close": "关闭",
    "delivering": "正在交付…",
    "publishDraft": "推送分支并创建草稿",
    "delivered": "草稿 Pull request 已创建。",
    "openPR": "打开 Pull request",
    "deliveryExplanation": "勾选已审阅的文件。操作会使用设备上的 Git 和 GitHub CLI 凭据推送独立分支；当前分支、文件和暂存区会保留。",
    "defaultBase": "目标：仓库默认分支",
    "prTitle": "Pull request 标题",
    "prBody": "说明（可选）",
    "selectFiles": "选择要交付的文件",
    "viewPatch": "审阅 diff",

    "title": "任务信息",
    "changes": "改动",
    "details": "详情",
    "upgradeRequired": "升级此设备上的 jcode 后，即可查看工作区改动。",
    "setup": "设备连接指南",
    "files": "{count} 个文件",
    "refresh": "刷新",
    "offline": "设备已离线，重新连接后可刷新改动。",
    "workspaceChanges": "工作区相对于 HEAD 的当前改动，包含任务开始前已有的改动。",
    "clean": "工作区没有未提交的改动。",
    "truncated": "改动超过显示上限，当前预览不完整。请在设备上检查完整改动。",
    "updated": "更新于 {time}",
    "device": "设备",
    "workspace": "工作区",
    "branch": "分支",
    "model": "模型",
    "connection": "连接状态",
    "online": "在线",
    "offlineLabel": "离线",
    "version": "jcode 版本",
    "openDevice": "打开设备",
    "binary": "二进制文件，请在设备上查看内容。"
},
  cloudRefresh: {
    "noGitProviders": "尚未配置 Git 登录提供方，请联系管理员配置提供方连接。",
    "sessionNotFound": "找不到这个会话",
    "addAttachments": "添加文件",
    "uploading": "上传中…",
    "attachmentReady": "已添加",
    "attachmentExpired": "已过期，请重新上传",
    "uploadFailed": "上传失败，请重试或移除文件。若附件存储不可用，请联系管理员。",
    "attachmentLimits": "最多 10 个文件，单个不超过 25 MiB，总计不超过 100 MiB；不支持空文件。",
    "removeAttachment": "移除 {name}",

    "navigationFailed": "无法加载最近工作。",
    "accountRequired": "请使用个人账号登录，以管理这些设置。",
    "noMatchingDevices": "没有匹配的设备",
    "personalModelsEmpty": "在模型设置中添加个人提供方，或请管理员授权模型。",

    "personalModelsDescription": "个人模型可用于你有权访问的仓库。",
    "updateCredentials": "更新凭据",
    "enable": "启用",
    "disable": "停用",
    "deleteModel": "删除 {name}",
    "deleteModelConfirm": "确认删除模型 {name}？",
    "availableModels": "可用于任务的模型",

    "defaultModel": "默认模型",
    "automaticModel": "自动选择可用模型",
    "unavailableModel": "模型不可用，请重新选择",
    "defaultPermission": "默认执行权限",
    "askApproval": "操作前审批",
    "fullAccess": "完全访问",
    "planMode": "仅规划",
    "defaultEffort": "默认推理强度",
    "effort_auto": "自动",
    "effort_low": "低",
    "effort_medium": "中",
    "effort_high": "高",
    "light": "浅色",
    "dark": "深色",
    "sendKey": "消息发送方式",

    "recentRepositories": "最近仓库",
    "remoteDevices": "远程设备",
    "recentConversations": "最近对话",
    "allRepositories": "所有仓库",
    "personalWorkspace": "个人工作区",
    "homeTitle": "下一步，想做什么？",
    "homeDescription": "从一个想法开始，让 jcode 帮你推进。",
    "searchTasks": "搜索任务",
    "all": "全部",
    "active": "进行中",
    "attention": "需关注",
    "completed": "已完成",
    "noMatch": "没有匹配的任务",
    "noMatchDescription": "试试其他关键词，或清除筛选条件。",
    "clearFilters": "清除筛选",
    "connectDevice": "连接设备",
    "searchDevices": "搜索设备",
    "devicesTitle": "你的设备，随时接着工作",
    "devicesDescription": "在已登录 jcode 的设备上，打开工作区并继续对话。",
    "noDevices": "还没有连接设备",
    "noDevicesDescription": "连接设备上的 jcode，开始远程工作。",
    "backDevices": "返回远程设备",
    "startRemote": "开始远程任务",
    "recentSessions": "最近会话",
    "deviceNotFound": "找不到这台设备",
    "deviceUnavailable": "设备不可用，或当前账号没有访问权限。",
    "encryptedSession": "会话内容已加密",
    "pairToRead": "配对此浏览器后才能查看会话。"
},
  cloudDeviceGuide: {
    installHint: '在这台设备上安装最新版 jcode，以使用远程工作区功能。',
    download: '下载或更新 jcode',
    "secure": "端到端加密连接",
    "section": "远程连接",
    "title": "连接 jcode 设备",
    "description": "登录并授权设备，再与此浏览器配对，即可打开加密工作区和会话。",
    "steps": "设备连接步骤",
    "login": "登录 jcode",
    "approve": "授权设备",
    "pair": "加密配对",
    "newDevice": "新建远程连接",
    "minute": "约一分钟",
    "runCommand": "运行登录命令",
    "getCode": "获取一次性设备码",
    "confirmIdentity": "确认设备身份",
    "approveAccount": "允许关联当前账号",
    "completePair": "完成配对",
    "approveLocal": "在本地 jcode 中确认",
    "onDevice": "在需要连接的设备上",
    "runLogin": "运行 jcode login",
    "commandDescription": "命令将生成一次性授权码，并自动打开浏览器。如果未自动打开，请在下方输入设备码。",
    "terminal": "终端",
    "copyCommand": "复制登录命令",
    "copyError": "复制失败，请选中上方命令手动复制。",
    "enterCode": "输入 CLI 显示的设备码",
    "continue": "继续授权",
    "ciphertext": "云端仅转发密文",
    "ciphertextDescription": "设备码将此次登录关联到你的账号。配对密钥仅保留在 jcode 和此浏览器，服务器无法读取会话内容。",
    "connected": "已连接的设备",
    "connectedDescription": "打开设备工作区，或继续上方步骤添加另一台设备。",
    "expires": "授权码的剩余有效期会显示在 jcode 中。"
},
  common: {
    ok: '确定',
    add: '添加',
    back: '返回',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    saving: '保存中…',
    saved: '已保存',
    delete: '删除',
    remove: '移除',
    edit: '编辑',
    rename: '重命名',
    retry: '重试',
    loading: '加载中…',
    enable: '启用',
    disable: '禁用',
    search: '搜索',
    done: '完成',
    other: '其他',
    details: '详情',
    connected: '已连接',
    disconnected: '未连接',
    configured: '已配置',
    notConfigured: '未配置',
    recommended: '推荐',
    copy: '复制',
    copied: '已复制',
    dismiss: '忽略',
    create: '创建',
    creating: '创建中…',
    confirm: '确认',
    continue: '继续',
  },

  language: {
    label: '语言',
  },

  format: {
    justNow: '刚刚',
    minutesAgo: '{n}分钟前',
    hoursAgo: '{n}小时前',
    daysAgo: '{n}天前',
    durationSeconds: '{n}秒',
    durationMinutes: '{m}分',
    durationMinutesSeconds: '{m}分{s}秒',
    durationHoursMinutes: '{h}小时{m}分',
  },

  run: {
    permissionArgumentsUnavailable: '这条旧审批记录未保存实际参数。',
    thinking: '思考中',
    thinkingAria: '思考中…',
    projectMember: '仓库成员',
    toolStatusDone: '完成',
    tool: {
      read: '读取项目上下文',
      edit: '编辑文件',
      execute: '运行命令',
      search: '搜索工作区',
    },
    toolStatus: {
      running: '运行中',
      failed: '失败',
      queued: '排队中',
      canceled: '已取消',
    },
    statusName: {
      queued: '排队中',
      running: '运行中',
      succeeded: '已成功',
      failed: '已失败',
      canceled: '已取消',
      scheduling: '调度中',
      awaiting_input: '等待输入',
      blocked: '已阻塞',
    },
    unknownStatus: '未知',
    finalStatus: '最终状态：{status}',
    status: '状态：{status}',
    artifactReady: '产物就绪：{artifact}',
    pushedAt: '已推送 {branch}（{sha}）',
    pushed: '已推送 {branch}',
    result: {
      noChanges: '无代码变更',
      generic: '结果',
    },
    session: {
      resumed: '会话已恢复',
      established: '会话已建立',
      finished: '会话已结束',
      finishedIdle: '会话已结束（空闲超时）',
    },
    permissionTimedOut: '权限已超时',
    permissionResolved: '权限已解决',
    unknownEvent: '未知事件：{type}',
    toolStarted: '{tool} 已开始',
    toolFailed: '{tool} 失败',
    toolCompleted: '{tool} 已完成',
    permission: {
      label: '权限',
      required: '需要权限',
      noAction: '无操作（已取消）',
      timedOut: '已超时',
      resolved: '已解决',
      answered: '已回答 — 等待 agent…',
      readonly: '只读 — 仓库成员可以回答。',
    },
  },

  workspace: {
    provider: {
      pathOrUrl: '路径 / 远程 URL',
      gitRepository: 'Git 仓库',
    },
    runKind: {
      review: '审查',
      prEvent: 'PR 事件',
      schedule: '定时',
      kanban: 'Kanban',
      webhook: 'Webhook',
      session: '会话',
      task: '任务',
    },
  },

  shell: {
    skipToContent: '跳到内容',
    globalNav: '全局导航',
    primaryNav: '主要',
    workspaceEyebrow: '工作区',
    adminEyebrow: '管理',
    clusterTitle: 'Cluster',
    cloudTitle: 'jcode Cloud',
    clusterSubtitle: 'Cluster 配置',
    cloudSubtitle: '自托管编码工作区',
    projects: '项目',
    cluster: 'Cluster',
    devices: '设备',
    clusterSections: 'Cluster 分区',
    adminBadge: '管理员',
    recentProjects: '最近的 Repositories',
    recentEmpty: '你打开过的 Repository 会作为快捷方式显示在这里。',
    recentAria: '最近的 Repositories',
    workspaceAria: 'jcode Cloud 工作区',
    demoEnv: 'demo / 本地',
    orchestratorEnv: '编排器',
    demoTag: 'DEMO',
    switchToLight: '切换到浅色模式',
    switchToDark: '切换到深色模式',
    services_one: '{count} 个服务',
    services_other: '{count} 个服务',
    crumbProjects: '项目',
    crumbNewProject: '新建项目',
    crumbCluster: 'Cluster',
    crumbModels: '模型',
    crumbConnections: '连接',
    crumbOverview: '概览',
    crumbWorkspace: '工作区',
    crumbProject: '项目',
    crumbDevice: '设备',
    crumbSession: '会话',
    crumbNotFound: '未找到',
  },

  cluster: {
    accessDenied: {
      roleCode: '角色 / 项目管理员',
      title: 'Cluster 不在此角色范围内。',
      body: '你的角色仅管理仓库。容量、模型凭据、护栏和提供方配置需要 Cluster 管理员。',
      noticeTitle: 'Cluster 导航被有意隐藏。',
      noticeBody: '此直接路由解释了该边界，而不会发出系统快照请求。',
      backToProjects: '返回仓库',
    },
    overview: {
      loadingSnapshot: '加载 Cluster 快照…',
      snapshotLoadError: '无法加载 Cluster 快照',
      eyebrow: '编排器快照',
      title: 'Cluster',
      description: '此编排器的容量、护栏和运行时接线。可编辑的配置保留在其所属分区中。',
      metaNamespace: '命名空间 / {value}',
      metaLauncher: '启动器 / {value}',
      metaCommit: '提交 / {value}',
      snapshotLoaded: '快照已加载',
      refresh: '刷新',
      capacitySummaryAria: '运行容量摘要',
      metricRunning: '运行中',
      metricRunningNote: '当前活跃',
      metricScheduling: '调度中',
      metricSchedulingNote: '等待 pod',
      metricQueued: '排队中',
      metricQueuedNote: '等待容量',
      metricMax: '上限',
      metricMaxNote: '并发运行',
      capacityTitle: '容量',
      capacityAside: '{active} 活跃 / {max} 上限',
      concurrencyUncapped: '并发未设上限',
      concurrencyInUse: '的已配置并发正在使用中',
      unlimitedSlots: '无限槽位',
      slotsAvailable: '{count} 个可用槽位',
      legendRunning: '{count} 运行中',
      legendScheduling: '{count} 调度中',
      gitPolicyTitle: 'Git 提供方策略',
      giteaEnabled: 'Gitea 已启用',
      giteaDisabled: 'Gitea 已禁用',
      giteaUrlLabel: 'Gitea URL',
      draftPrLabel: '草稿 PR 输出',
      draftPrAvailable: '对已授权身份可用',
      draftPrUnavailable: '不可用 — 仅 diff',
      allowedHostsLabel: '允许的 Git 主机',
      unrestricted: '不限制',
      modelsConfigured_one: '已配置 {count} 个目录模型。',
      modelsConfigured_other: '已配置 {count} 个目录模型。',
      modelsManagedPrefix: '模型凭据和账号授权在 ',
      modelsLink: '模型',
      modelsManagedSuffix: ' 中管理；账号和仓库永远不会收到提供方密钥。',
      guardrailsTitle: '护栏',
      runTimeoutLabel: '运行超时',
      jobTtlLabel: 'Job TTL',
      runnerTitle: '运行器',
      imageLabel: '镜像',
      launcherLabel: '启动器',
      workspaceLabel: '工作区',
      persistent: '持久',
      ephemeral: '临时',
      prewarmLabel: '镜像预下载',
      prewarmUnsupported: '需要 Kubernetes 启动器',
      prewarmNever: '尚未同步',
      prewarmReady: '{ready}/{desired} 节点已缓存',
      prewarmLastSyncLabel: '上次同步',
      prewarmSync: '同步最新镜像',
      prewarmSyncError: '同步失败,请查看 orchestrator 日志',
      buildTitle: '构建',
      versionLabel: '版本',
      commitLabel: '提交',
      usersLabel: '用户',
      coldArchiveUnavailable: '冷归档不可用。',
    },
    models: {
      contextUnknown: '上下文未知',
      contextK: '{value}K 上下文',
      context: '{value} 上下文',
      eyebrow: 'Cluster 目录',
      title: '模型提供方',
      description: '只需连接一次提供方并密封保存凭据，再将模型访问权限直接授予账号。',
      addProvider: '添加提供方',
      securityNote: '提供方密钥仅可写入。目录仅报告是否已配置凭据，绝不会显示所存储值的任何部分。',
      filterLabel: '筛选模型或提供方',
      filterPlaceholder: '筛选模型或提供方…',
      resultCount: '/ {total} 个模型',
      configuredProviders: '已配置的提供方',
      providersSummary: '{providers} 个提供方 · {accountGrants} 项账号授权',
      loadingProviders: '加载模型提供方…',
      loadProvidersError: '无法加载模型提供方',
      noMatches: '没有匹配的模型或提供方。',
      noProviders: '未配置模型提供方。',
      noMatchesHint: '试试提供方名称、模型 id 或能力。',
      noProvidersHint: '添加提供方，使模型可供账号在 Desktop 和仓库任务中使用。',
      authServiceIdentity: '服务身份',
      authKeySet: '已设置密钥',
      authKeyless: '无密钥',
      authKeyMissing: '缺少密钥',
      verifiedIn: '提供方已在 {ms} ms 内验证。',
      reachableIn: '提供方在 {ms} ms 内可达；目录不可用。',
      verifyError: '无法验证提供方。',
      removeConfirm: '移除 {name} 及其所有已配置的模型？',
      providerRemoved: '提供方已移除。',
      removeError: '无法移除提供方。',
      customLabel: '自定义',
      credKeylessIdentity: '无密钥工作负载身份',
      credConfigured: '已配置凭据',
      credNoneRequired: '无需凭据',
      credRequired: '需要凭据',
      lastTest: '上次测试：{error}',
      verified: '已验证',
      test: '测试',
      editProviderAria: '编辑 {name} 提供方',
      removeProviderAria: '移除 {name} 提供方',
      customModel: '自定义模型',
      configuredModel: '已配置模型',
      configuredModels: '已配置模型',
      catalogUnavailable: '目录不可用',
      browseCatalog: '浏览目录',
      customModelAction: '自定义模型',
      limitNote: '此端点不公开模型目录。必须显式添加模型；不会替换任何回退目录。',
      capabilitiesAria: '模型能力',
      capReasoning: '推理',
      capTools: '工具',
      capImage: '图片',
      projectGrants_one: '项目授权',
      projectGrants_other: '项目授权',
      accountGrants_one: '账号授权',
      accountGrants_other: '账号授权',
      manageAccess: '管理访问',
      capabilitiesLegend: '能力',
      capToolUse: '工具调用',
      capImageInput: '图片输入',
      customValidationRequired: '显示名称和模型 ID 为必填项。',
      customValidationContext: '上下文窗口必须为零或正数。',
      customAdded: '自定义模型已添加。',
      addModelError: '无法添加模型。',
      customDialogTitle: '自定义模型 · {name}',
      addCustomModel: '添加自定义模型',
      displayNameLabel: '显示名称',
      displayNamePlaceholder: '例如 Coding Plan',
      modelIdLabel: '模型 ID',
      modelIdHint: '纯上游模型 id；运行时提供方前缀会在服务器端添加。',
      contextWindowLabel: '上下文窗口',
      modelAdded: '{name} 已添加。',
      addCatalogError: '无法添加目录模型。',
      syncMetadata: '同步元数据',
      metadataSynced: '{name} 元数据已同步。',
      syncMetadataError: '无法同步模型元数据。',
      catalogDialogTitle: '目录 · {name}',
      loadingCatalog: '加载提供方目录…',
      catalogLoadError: '无法加载目录',
      catalogLoadFallback: '无法加载提供方目录。',
      grantUpdateError: '无法更新项目授权。',
      accountGrantUpdateError: '无法更新账号访问权限。',
      accessDialogTitle: '模型访问 · {name}',
      accessIntro: '一次按账号授权，同时用于 Cloud 和 Desktop。提供方凭据始终密封在 Cluster 边界内。',
      accessTabsAria: '模型访问范围',
      accessAccounts: '账号',
      accessProjects: '项目',
      accountAccessIntro: '授权后，该账号的 Repository 任务以及当前和以后的所有 Desktop 都可使用此模型。',
      projectAccessIntro: '获授权的项目可在 Cloud 任务中选择此模型。',
      accountSearchLabel: '搜索账号',
      accountSearchPlaceholder: '搜索账号…',
      loadingAccounts: '加载账号…',
      noAccounts: '没有匹配的账号。',
      allDesktops: '当前及以后新增的全部 Desktop',
      allCloudAndDesktop: '全部 Repository 任务和 Desktop',
      clusterAdminAccount: 'Cluster 管理员 · 全部 Desktop',
      loadingProjects: '加载项目…',
      noProjects: '还没有项目。',
      servicesCount: '{count} 个服务',
      providerValidationRequired: '名称、提供方类型和 Base URL 为必填项。',
      providerValidationKey: '新的 API 密钥提供方需要 API 密钥。',
      providerSaved: '提供方已保存。',
      saveProviderError: '无法保存提供方。',
      providerAdded: '提供方已添加。',
      addProviderError: '无法添加提供方。',
      editProviderTitle: '编辑提供方 · {name}',
      addProviderTitle: '添加模型提供方',
      saveProvider: '保存提供方',
      providerSourceLabel: '提供方来源',
      providerRegistryMode: '提供方',
      providerCustomMode: '自定义',
      providerSelectLabel: '提供方',
      providerSelectPlaceholder: '选择提供方',
      providerNameLabel: '提供方名称',
      providerNamePlaceholder: '例如 Zhipu AI',
      providerTypeLabel: '提供方类型',
      providerTypeHint: '小写的运行时前缀，例如 openai、qwen 或 zhipu。',
      baseUrlLabel: 'Base URL',
      authLabel: '认证',
      authApiKey: 'API 密钥',
      authServiceIdentityOption: '服务身份',
      authNone: '无凭据',
      rotateApiKeyLabel: '轮换 API 密钥',
      apiKeyPlaceholderKeep: '留空以保留当前密钥',
      apiKeyPlaceholderEnter: '输入提供方密钥',
      apiKeyHint: '仅可写入。保存的值永远无法回读。',
      catalogLabel: '模型目录',
      catalogAuto: '从 /models 发现',
      catalogDisabled: '不可用 — 仅自定义模型',
      advancedLabel: '高级',
      headersHint: '随每次请求发送到该提供方的自定义 Header。值仅可写入。',
      headersConfiguredHint: '已配置自定义 Header。添加行以替换，或留空以保留。',
      headerKeyPlaceholder: 'Header 名称',
      headerValuePlaceholder: '值',
      addHeader: '添加 Header',
      removeHeader: '移除 Header',
      headerValidation: '每个 Header 都需要同时填写名称和值。',
    },
    connections: {
      loading: '加载 Cluster 连接…',
      statusError: '无法加载连接状态',
      configError: '无法加载 jtype 配置',
      eyebrow: '外部系统',
      title: '连接',
      description: 'Cluster 范围的端点和身份提供方。仓库授权保留在各个仓库连接中。',
      configurationTabs: '连接配置',
      integrationsTab: '集成配置',
      loginTab: '登录设置',
      statusEyebrow: '生效状态',
      statusTitle: '连接状态',
      statusDescription: 'Cluster 报告的只读运行状态，与可编辑的提供方配置分开显示。',
      configuredCount: '已配置 {count} 个',
      gitPolicyTitle: 'Git 提供方策略',
      gitPolicySubtitle: '由环境管理 · 只读',
      giteaEnabled: 'Gitea 已启用',
      giteaDisabled: 'Gitea 已禁用',
      giteaUrlLabel: 'Gitea URL',
      clusterPatLabel: 'Cluster PAT',
      patConfigured: '已配置 · 值已隐藏',
      allowedHostsLabel: '允许的主机',
      unrestricted: '不限制',
      oobTitle: '更改在带外进行。',
      oobBody: '提供方 URL、PAT 和主机允许列表仍属于部署配置；此页面报告生效状态。',
      authTitle: '认证',
      registeredUsers: '{count} 个已注册用户',
      oauthOn: 'OAuth 已开启',
      tokenOnly: '仅令牌',
      giteaOauthLabel: 'Gitea OAuth',
      githubOauthLabel: 'GitHub OAuth',
      consoleTokenLabel: '控制台令牌',
      consoleTokenValue: 'Cluster 管理员回退',
      oauthSecurityNote: 'OAuth 重定向 URI 需通过提供方 UI 更改，因为 API 补丁操作会轮换客户端密钥。',
      githubUnavailableTitle: 'GitHub 登录不可用。',
      githubUnavailableBody: '未配置 GitHub OAuth 提供方。在提供方存在之前，UI 不会显示可用的 GitHub 按钮。',
      providerHealth: {
        unknown: '尚未检测',
        healthy: '正常',
        partial: '基础连接正常',
        error: '错误',
        incomplete: '配置不完整',
      },
      providerHealthError: '连接检查失败：{message}',
      githubAppSetupIncomplete: 'GitHub App 设置不完整',
      instanceUrl: '实例 URL',
      providerCapabilities: '提供方能力',
      loginEnabled: '已启用登录',
      loginCapability: '登录',
      loginCapabilityHint: '允许使用此提供方登录 Cloud。',
      pluginEnabled: '已启用插件',
      pluginCapability: '插件',
      pluginCapabilityHint: '允许仓库连接并使用该插件。',
      oauthClientId: 'OAuth 客户端 ID',
      oauthClientSecret: 'OAuth 客户端密钥',
      configuredReplace: '已配置 — 输入新值以替换',
      enterSecret: '输入密钥',
      githubAppId: 'GitHub App ID',
      githubAppPrivateKey: 'GitHub App 私钥',
      configuredPemReplace: '已配置 — 粘贴 PEM 以替换',
      pastePrivateKeyPem: '粘贴完整的私钥 PEM',
      privateKeyHint: '仅可写入。Cloud 会加密 PEM，且绝不会将其返回浏览器。',
      webhookSecret: 'Webhook 密钥',
      webhookSecretPlaceholder: '输入与 GitHub 中配置相同的密钥',
      githubAppConfigurationIncomplete: 'GitHub App 配置不完整',
      githubAppConfigurationIncompleteHint: '请添加 App ID、私钥及匹配的 Webhook 密钥，之后账号才能列出 Installation。',
      testConnection: '测试连接',
      jtypeSaved: 'jtype 连接已保存。',
      jtypeSaveError: '无法保存 jtype。',
      jtypeOverrideRemoved: 'jtype 数据库覆盖已移除。',
      jtypeRemoveError: '无法移除覆盖。',
      sourceDb: '数据库覆盖',
      sourceEnv: '环境回退',
      sourceNone: '未配置',
      jtypeKanban: 'jtype Kanban',
      pollingEvery: '每 {interval} 轮询一次',
      jtypeEffective: '生效',
      jtypeBroken: '已损坏',
      jtypeOff: '关闭',
      baseUrlLabel: 'Base URL',
      baseUrlHint: '本集群连接的 jtype 实例。看板凭据完全由各项目所有者按链接管理。',
      boardTrafficNote: '看板流量通过服务器代理传输。jtype 令牌绝不会进入浏览器。',
      jtypeUnavailableTitle: 'jtype 配置不可用。',
      removeOverride: '移除覆盖',
      saveJtype: '保存 jtype',
      archiveTitle: '工作区归档',
      archiveSubtitle: '持久工作区冷存储',
      archiveEnabled: '已启用',
      archiveUnavailable: '不可用',
      endpointLabel: '端点',
      bucketLabel: '存储桶',
      idleWindowLabel: '空闲窗口',
      idleDays: '{count} 天',
      archiveDisabledTitle: '长期归档未启用。',
      archiveDisabledReason: '对象存储未配置。',
    },
    system: {
      forbiddenTitle: 'Cluster 视图仅供 Cluster 管理员',
      forbiddenDescription: '你的角色仅管理项目。请向 Cluster 管理员询问容量、护栏和提供方详情。',
      title: 'Cluster',
      subtitle: '此编排器的快照：容量、护栏和接线。模型在此配置；其他更改在带外进行（env / kubectl）。',
      loadingSnapshot: '加载 Cluster 快照…',
      snapshotError: '无法加载 Cluster 快照',
      noSnapshotTitle: '无快照',
      noSnapshotDescription: '编排器未返回系统信息。',
      capacityTitle: '容量',
      unlimitedConcurrency: '无限并发',
      activeMax: '{active} 活跃 / {max} 上限',
      capacityBarAria: '活跃运行相对最大并发',
      statRunning: '运行中',
      statScheduling: '调度中',
      statQueued: '排队中',
      statMaxConcurrent: '最大并发',
      guardrailsTitle: '护栏',
      runTimeoutLabel: '运行超时',
      jobTtlLabel: 'Job TTL',
      providerTitle: '提供方',
      giteaEnabled: 'Gitea 已启用',
      giteaDisabled: 'Gitea 已禁用',
      draftPrsLabel: '草稿 PR',
      on: '开启',
      offDiffOnly: '关闭（仅 diff）',
      giteaUrlLabel: 'Gitea URL',
      allowedHostsLabel: '允许的 Git 主机',
      unrestrictedAnyHost: '不限制（任意主机）',
      allowedHostsHint: '项目集成只能以这些主机为目标（ALLOWED_GIT_HOSTS）。为空 = 任意主机。',
      runnerTitle: '运行器',
      imageLabel: '镜像',
      namespaceLabel: '命名空间',
      launcherLabel: '启动器',
      persistentWorkspaceLabel: '持久工作区',
      off: '关闭',
      authTitle: '认证',
      providerCount_one: '{count} 个提供方',
      providerCount_other: '{count} 个提供方',
      tokenOnly: '仅令牌',
      oauthProvidersLabel: 'OAuth 提供方',
      noneConsoleToken: '无（仅控制台令牌）',
      usersLabel: '用户',
      versionTitle: '版本',
      orchestratorLabel: '编排器',
      commitLabel: '提交',
      modelCatalogTitle: '模型目录',
      modelCount_one: '{count} 个模型',
      modelCount_other: '{count} 个模型',
      noModels: '无模型',
      modelCatalogHint: '注册 OpenAI 兼容端点，然后按项目授权它们。在项目至少拥有一个已授权模型之前，其运行会被阻止。',
      loadingModelCatalog: '加载模型目录…',
      modelCatalogError: '无法加载模型目录',
      noModelsYet: '还没有模型 — 在下方添加一个。',
      keySet: '已设置密钥',
      keyless: '无密钥',
      modelSaved: '模型已保存。',
      modelSaveError: '无法保存模型。',
      modelRemoved: '模型已移除。',
      modelRemoveError: '无法移除模型。',
      nameLabel: '名称',
      baseUrlLabel: 'Base URL',
      modelProviderLabel: '模型（提供方/模型）',
      apiKeyLabel: 'API 密钥',
      apiKeyPlaceholderClear: '将被清除（无密钥）',
      apiKeyPlaceholderRotate: '•••••••• （留空 = 不变；输入以轮换）',
      apiKeyPlaceholderNew: 'sk-…  （留空表示无密钥）',
      apiKeyHint: '加密存储。保存后绝不显示。',
      clearKeyLabel: '清除密钥（使此端点无密钥）',
      noProjectsToAuthorize: '还没有可授权的项目。',
      authorizedProjects: '已授权项目',
      grantUpdateError: '无法更新授权。',
      modelAdded: '模型已添加。',
      modelAddError: '无法添加模型。',
      apiKeyPlaceholderAdd: 'sk-…  （留空表示无密钥端点）',
      addModel: '添加模型',
    },
  },

  app: {
    linked: '已关联你的 {provider} 账户。',
    linkTaken: '该账户已关联到另一个用户。',
    linkError: '无法关联该账户。',
    auth: {
      loginProviderDenied: '提供方拒绝了登录请求。请重试。',
      loginExchangeFailed: '登录无法完成（令牌交换失败）。',
      loginProfileFailed: '登录无法从提供方读取你的资料。',
      loginServerMisconfigured: '服务器未配置登录。',
      loginServerError: '服务器在完成登录时遇到错误。',
      loginFailed: '登录失败。请重试。',
      enterToken: '输入控制台令牌。',
      superseded: '已被取代。',
      tokenRejected: '令牌被编排器拒绝。',
      lostOrchestrator: '已失去编排器连接 — 请查看设置步骤。',
    },
  },

  components: {
    modelGate: {
      unverified: '无法验证模型状态 — 如果没有可用模型，运行可能会失败。',
      notConfigured: '该项目没有可用模型，因此无法启动运行。',
      grantLink: '在 Cluster 页面授权一个模型',
      contactAdmin: '请联系 Cluster 管理员为此项目授权一个模型。',
    },
    prPanel: {
      stateOpen: '打开',
      stateMerged: '已合并',
      stateClosed: '已关闭',
      stateUnknown: '未知',
      stateAria: '拉取请求状态：{state}',
      reviewRequested: '已请求 AI 审查。',
      reviewError: '无法请求审查。',
      loading: '加载拉取请求…',
      loadError: '无法加载拉取请求',
      noPr: '尚未创建拉取请求。',
      requestReview: '请求 AI 审查',
      reviewsTitle: '审查',
      reviewsEmpty: '还没有 AI 审查。',
      hide: '隐藏',
      show: '显示',
      reviewFailed: '审查运行在生成输出前失败。',
      reviewInProgress: '审查进行中…',
    },
    states: {
      cannotReach: '无法连接编排器。它在运行吗？',
      somethingWrong: '出错了。',
      failedToLoad: '加载失败',
    },
    statusBadge: {
      queued: '排队中',
      scheduling: '调度中',
      running: '运行中',
      awaitingInput: '等待输入',
      succeeded: '已成功',
      failed: '已失败',
      canceled: '已取消',
      blocked: '已阻塞',
      aria: '状态：{status}',
    },
    gitMode: {
      legend: 'Git 集成',
      modeAria: 'Git 集成模式',
      readonlyLabel: '仅 Diff',
      readonlyHint: '成功的运行仅生成 diff 产物 — 不会推送任何内容。',
      draftPrLabel: 'Pull request',
      draftPrHint: '可信控制面会推送隔离分支并管理 Pull Request。系统不会自动合并；仓库 workflow 仍可能由 push 或 PR 事件触发。',
      draftPrTitle: '成功的运行通过 Pull Request 交付变更。',
      readonlyTitle: '成功的运行仅生成 diff 产物 — 不会推送任何内容。',
    },
    identity: {
      roleClusterAdmin: 'Cluster 管理员',
      roleProjectAdmin: '仓库管理员',
      signOut: '退出登录',
      serviceNote: '使用控制台令牌认证 — 无关联身份。',
      session: '会话',
      linkedAccounts: '关联的账户',
      noLinkedAccounts: '还没有关联的账户。',
      linkAnother: '关联另一个',
      link: '关联 {name}',
    },
    kanbanConnect: {
      startError: '无法启动连接流程。',
      connect: '使用 jtype 连接',
      enterCode: '在 jtype 中输入此代码以授权：',
      openJtype: '打开 jtype 以授权',
      waiting: '等待你在 jtype 中授权…',
      connected: '已连接 — 已设置令牌',
      failed: '连接失败 — 请再次点击连接。',
      expired: '连接已过期 — 请再次点击连接。',
      unsupported: '此 jtype 部署不支持一键连接 — 请改为粘贴令牌。',
      expiryExpired: '已过期',
      expiresInDays_one: '{count} 天后过期',
      expiresInDays_other: '{count} 天后过期',
    },
    projectSwitcher: {
      allProjects: '所有项目',
      noProjects: '暂无项目',
    },
    modal: {
      close: '关闭对话框',
    },
  },


  members: {
    addedAs: '{name} 已添加为 {role}。',
    addError: '无法添加成员。',
    updateRoleError: '无法更新角色。',
    removed: '{name} 已移除。',
    removeError: '无法移除成员。',
    searchPlaceholder: '按姓名搜索用户…',
    searchAria: '搜索要添加的用户',
    searching: '搜索中…',
    noMatches: '没有匹配的用户。',
    adminTag: '管理员',
    roleForAddedAria: '所添加成员的角色',
    roleForAria: '{name} 的角色',
    removeAria: '移除 {name}',
    loading: '加载成员…',
    loadError: '无法加载成员',
    roleOwner: '所有者',
    roleMember: '成员',
    roleViewer: '查看者',
  },


  kanban: {
    enableTitle: '连接 Agent Board',
    enableBody: '选择已有 Board、执行模型，以及用于触发、处理中和可选完成的列。',
    pluginRequired: '请先连接 JType 并选择其工作区，再绑定 Agent Board。',
    loadingAccountModels: '正在加载账号模型…',
    accountModelsUnavailable: '无法加载账号模型。',
    accountModelRequired: '启用 Agent Board 前，请先为此账号授权至少一个模型。',
    loadingBoards: '正在加载看板…',
    boardsUnavailable: '无法加载看板，请检查 JType 插件连接。',
    enable: '连接 Agent Board',
    disable: '断开连接',
    triggerColumn: '触发列',
	workColumn: '进行中列',
    doneColumn: '完成列',
    noDoneColumn: '完成后不移动卡片',
    columnSettings: '自动化列',
    columnSettingsHint: '行内编辑卡片如何启动任务，以及完成后移动到哪里。',
    columnsUnavailable: '无法加载列选项，请检查 JType 插件连接。',
    notConfiguredTitle: 'Kanban 尚未配置',
    notConfiguredMsg: '在此看板可以打开之前，Cluster 管理员需要配置 jtype 集成。',
    tlsInvalidTitle: 'JType 证书需要修复',
    tlsInvalidMsg: '无法验证 JType 的 HTTPS 证书。请联系管理员续期或修复证书，然后重试。',
    unavailableTitle: 'Kanban 不可用',
    unavailableMsg: '无法连接 jtype 服务。请在服务可用时重试。',
    unauthorizedTitle: 'Kanban 访问需要关注',
    unauthorizedMsg: '当前 JType 连接无法读取此 Board。Repository owner 或 Cluster 管理员需要修复连接。',
    workspaceNotFoundTitle: '未找到 Kanban 工作区',
    workspaceNotFoundMsg: '此 Agent Board 指向的 JType 工作区已不可用。',
    boardNotFoundTitle: '无法打开此看板',
    boardNotFoundMsg: '该看板可能已被删除或重命名，或者集成失去了访问权限。',
    boardOpenDefaultMsg: '目前无法打开 Board。请重试，或请 Repository owner 检查连接。',
    title: 'Agent Board',
    boardLabel: '看板',
    openingBoard: '正在打开看板…',
    loadingPolicy: '正在加载执行策略…',
    policyUnavailable: '无法加载执行策略。',
    policyTrigger: 'Card 进入 {column} 时启动 jcode',
	policyWork: '接收后将 Card 移入 {column}',
	policyWorkMissing: '接收后不会将 Card 移入 WIP',
    policyWriteback: '成功后评论并移动到 {column}',
    policyCommentOnly: '结果写入 Card 评论',
    policyReady: '可执行',
    policyBlocked: '已阻塞 · {blocker}',
    policyBlockers: {
      binding_disabled: '自动化已禁用',
      plugin_unavailable: 'JType 连接不可用',
      event_feed_unavailable: 'JType 事件流不可用',
      bootstrap_unavailable: 'JType 卡片初始化不可用',
      card_index_unavailable: 'JType 卡片索引不可用',
      card_read_unavailable: 'JType 卡片暂时无法读取',
      card_unavailable: 'JType 卡片不可用',
      board_validation_unavailable: 'JType 看板校验不可用',
      board_drift: '看板或自动化列已变更',
      repository_not_configured: '尚未配置代码仓库',
      repository_unavailable: '代码仓库连接不可用',
      provider_unavailable: '代码仓库 Provider 不可用',
      runner_unavailable: 'Runner 不可用',
      run_unavailable: '关联的 Cloud Run 不可用',
      model_not_configured: '尚未配置模型',
      model_not_authorized: '执行账号未获得该模型授权',
      model_authorization_unavailable: '暂时无法校验模型授权',
      execution_account_not_owner: '执行账号已不是 Repository owner',
      work_column_not_configured: '尚未配置处理中列',
      model_effort_unsupported: '模型不支持所选推理强度',
    },
    executionsTitle: 'Cloud 执行',
    loadingExecutions: '正在加载 Cloud 执行…',
    executionsUnavailable: '无法加载 Cloud 执行记录。',
    noExecutions: '尚无 Cloud 执行。将此 Card 移入“启动 jcode”列即可请求执行。',
    runWithAgent: '使用 Agent 执行',
    agentRunActive: 'Agent 正在执行',
    rerunDoneConfirm: '该 Card 已在 Done 列。仍要再次运行并将其移回处理中列吗？',
    executionState: {
      received: '已收到请求',
      blocked: '已阻塞',
      queued: '排队中',
      running: '执行中',
      terminal: '已结束',
      succeeded: '成功',
      failed: '失败',
      canceled: '已取消',
    },
    requestedByExternal: '请求者：{actor}',
    projectOwner: '项目所有者',
    repositoryOwner: '仓库所有者',
    clusterAdmin: '集群管理员',
    openRun: '打开 Run',
    writebackPending: 'Card 回写待完成',
    writebackUnavailable: '来源 Card 不可用',
    executionSummary: {
      received: '已收到 Card 请求。',
      queued: 'Run 正在排队。',
      running: 'Run 正在执行所请求的变更。',
      succeeded: 'Run 已成功完成。',
      failed: 'Run 执行失败。',
      canceled: 'Run 已取消。',
    },
    priorExecutions_one: '{count} 次历史执行',
    priorExecutions_other: '{count} 次历史执行',
    cardUnavailable: '此 Card 已不在 JType 中，Cloud 执行历史仍会保留。',
    loadEarlierExecutions: '加载更早的执行',
    linkDisabledTitle: '此 Kanban 自动化链接已禁用。',
    linkDisabledBody: '看板可查看，但卡片触发的运行和回写已禁用。',
  },

  onboarding: {
    setupStep1: '构建四个本地镜像',
    setupStep2: '部署到 OrbStack 集群并等待发布完成',
    setupStep3: '将编排器 API 转发到 localhost:8080',
    probingEyebrow: '连接中',
    probingTitle: '让运行时触手可及。',
    probingStory: '控制台正在检查是否可以开始已认证的工作流。',
    probingUtility: '连接设置',
    probingStatus: '探测中',
    setupEyebrow: '本地设置',
    setupTitle: '让运行时触手可及。',
    setupStory: '控制台已就绪。编排器尚未响应，因此无法开始任何已认证的工作流。',
    setupUtility: '连接设置',
    setupStatus: '无法访问',
    signinEyebrow: '你的代码。你的 Cluster。',
    signinTitle: '让工作贴近系统。',
    signinStory: 'jcode Cloud 将编码任务派发到你的团队已经掌控的基础设施中。',
    signinUtility: '安全入口',
    signinStatus: '登录',
    welcomeEyebrow: '工作区就绪',
    welcomeTitle: '第一道边界由你来设定。',
    welcomeStory: '你是第一个登录的人。jcode Cloud 已将 Cluster 管理员角色分配给此身份。',
    welcomeUtility: '首个用户设置',
    welcomeStatus: '已登录',
    landingEyebrow: '会话就绪',
    landingTitle: '控制平面触手可及。',
    landingStory: '控制台令牌为此浏览器建立了 Cluster 管理员会话。',
    landingUtility: '会话边界',
    landingStatus: '已认证',
    selfHosted: '自托管',
    assignedRole: '已分配角色',
    clusterAdministrator: 'Cluster 管理员',
    adminSeparate: 'Cluster 管理权限与仓库所有权是分开的。',
    roleManageGrants: '管理模型授权',
    roleConfigureConnections: '配置连接',
    roleViewCapacity: '查看容量与策略',
    sessionBoundary: '会话边界',
    whatSignInEstablishes: '登录会建立什么',
    signInEstablishesBody: '编排器会将提供方身份映射到一个 jcode Cloud 账号。仓库所有权和提供方访问权限会单独评估。',
    providerTokensServerSide: '提供方令牌保留在服务器端，绝不会渲染到此页面。',
    currentProbe: '当前探测',
    whatConsoleKnows: '控制台所知道的',
    probeBody: '此状态仅报告可达性。它不会推断 Kubernetes、镜像或凭据是否健康。',
    probeTarget: '目标',
    probeResponse: '响应',
    probeUnreachable: '无法访问',
    probeWaiting: '等待中',
    cantReachTitle: '无法连接编排器',
    setupLede1: '控制台将',
    setupLede2: '代理到',
    setupLede3: '，但没有响应。启动整个栈，然后此页面会自动继续。',
    recheckingNote: '每 3 秒重新检查一次 — 无需刷新',
    checkNow: '立即检查',
    reasonRejected: '保存的令牌被拒绝 — 它可能已被轮换。请输入当前令牌。',
    reasonExpired: '你的会话已结束（已过期或被撤销）。请重新登录。',
    reasonSignedOut: '已退出登录。',
    continueWith: '使用 {name} 继续',
    signInHeading: '登录',
    signInLedeNoProviders: '未配置 OAuth 提供方。请使用编排器部署时所用的控制台令牌。',
    signInLedeProviders: '使用你的 Git 提供方继续，以获取个人的、按用户划分的会话。',
    advancedConsoleToken: '高级：控制台令牌',
    consoleTokenLabel: '控制台令牌',
    consoleTokenHint: '编排器部署时所用的 CONSOLE_TOKEN — Cluster 管理员。本地存储在此浏览器中。',
    signInWithToken: '使用令牌登录',
    welcomeFirstAdminTitle: '你是第一个用户 — Cluster 管理员',
    welcomeGreeting: '欢迎，{name}',
    welcomeFirstAdminLede: '你是第一个登录的人，因此你现在是 Cluster 管理员：你可以查看每个项目并管理容量。在你之后加入的每个人都从普通用户开始。',
    welcomeLede: '你已登录。创建一个项目以将 jcode Cloud 指向某个仓库，或打开一个你已被添加进的项目。',
    friend: '朋友',
    signedInAs: '已登录为 {name}',
    getStarted: '开始使用',
    landingCardTitle: '你已进入 — Cluster 管理员',
    landingLede: '已登录到此编排器：',
    principal: '主体',
    access: '访问权限',
    accessClusterAdmin: 'Cluster 管理员',
    accessMember: '成员',
    session: '会话',
    sessionConsoleToken: '控制台令牌',
    sessionUser: '用户会话',
    identity: '身份',
    everythingHeadless: '一切都在你的 Cluster 中无界面运行。',
    enterConsole: '进入控制台',
    connecting: '正在连接编排器…',
    mobileHandoff: '正在为手机完成登录…',
    mobileConsentTitle: '在手机上登录',
    mobileConsentLede: '你已以 {name} 身份登录。点击下方按钮完成手机 App 登录。',
    mobileConsentContinue: '继续到 App',
  },

  notFound: {
    title: '此路径到此为止。',
    body: '页面可能已移动，或者该链接指向的仓库或任务你已无法访问。',
    backToProjects: '返回仓库',
  },

  device: {
    compose: {
      project: '工作目录',
      model: '模型',
      effort: '强度',
      goal: '目标',
      goalPlaceholder: '这个会话要达成什么？',
      attachments: '附件',
      attachAdd: '添加文件',
      removeAttachment: '移除 {name}',
      deviceDefault: '设备默认',
      attachmentTooBig: '{name} 超过 2 MB——请选择更小的文件。',
      attachmentTooMany: '每条消息最多 {max} 个附件。',
      attachmentImage: '{name} 是图片——暂不支持图片附件。',
    },
    composer: {
      placeholder: '输入消息，或键入 / 使用命令',
      goalPlaceholder: '描述目标——agent 会持续追求直到可验证地完成',
      queuePlaceholder: 'Agent 正在工作——输入以排队后续消息…',
      attachedImages: '（见附图）',
      send: '发送',
      queue: '排队',
      stop: '停止',
      stopAgent: '停止 agent (Esc)',
      stopAndNext: '停止当前回合并发送下一条排队消息',
      removeQueued: '从队列移除',
      add: '添加',
      attachFiles: '附加文件',
      command: '命令',
      goal: '目标',
      workflowBadge: '工作流',
      goalSlashDesc: '启用目标模式——下一条消息将成为目标',
      goalHintNext: '下一条消息将成为会话目标',
      goalHintNextReplaces: '下一条消息将替换当前目标',
      goalHintRemove: '移除目标',
      goalHintReplace: '设置新目标会替换当前目标',
      modelNoImages: '当前模型不支持图片',
      modeApproval: '逐次确认',
      modeApprovalSub: '每次写入或执行命令前暂停确认。',
      modePlan: '计划',
      modePlanSub: '先给出计划；批准前不执行任何操作。',
      modeAuto: '自动',
      modeAutoSub: 'AI 审查放行安全工具；不确定的仍会询问。',
      modeFullAccess: '完全放行',
      modeFullAccessSub: '自由执行——不再有审批提示。',
      modeCeilingHint: '云端会话最高可使用 Auto 模式。',
      modelFilter: '筛选模型…',
      modelCurrent: '当前',
      modelFavorites: '★ 收藏',
      modelReasoning: '推理',
      modelTools: '工具调用',
      modelImages: '图片输入',
      modelNoImageInput: '当前模型不支持图片输入',
      modelNone: '暂无可用模型',
      modelNoMatch: '没有匹配的模型。',
      modelManage: '管理模型…',
      modelManageTitle: '管理模型',
      modelToggleVisibility: '切换模型在选择器中的显示',
      modelVisibleCount: '选择器中显示 {visible}/{total} 个模型',
      effort: '推理强度',
      effortTitle: '该模型的推理强度',
      effortDefault: '默认',
      contextTitle: '上下文容量',
      contextSystemPrompt: '系统提示词',
      contextSystemTools: '系统工具',
      contextMcpTools: 'MCP 工具',
      contextSkills: '技能',
      contextMessages: '消息',
      contextInput: '输入',
      contextOutput: '输出',
      contextCached: '缓存',
      contextReasoning: '推理',
      contextCacheHitRate: '缓存命中率',
      workspaceNone: '选择文件夹',
      workspaceUnavailable: '无法读取当前文件夹。请重试、选择文件夹，或升级设备端 jcode 后使用 Chat。',
      workspaceNewConversation: '请返回设备页面，在新对话中选择工作区。',
      workspaceNonePlural: '暂无工作区',
      workspaceSearch: '搜索工作区',
      workspaceLoading: '加载中…',
      workspaceNoFolders: '没有文件夹',
      workspaceOpen: '打开',
      workspaceOpenFolder: '打开文件夹',
      workspaceOpenError: '打开工作区失败',
      workspacePathPlaceholder: '设备上的路径',
      remoteConnect: '远程连接',
      branchesTitle: '分支',
      branchesNone: '没有分支',
      branchSearch: '搜索分支',
      branchCreate: '创建并切换到新分支',
      branchCreateBtn: '创建',
      branchNewName: 'new-branch-name',
      branchCurrent: '分支：{name}',
      branchConfirmTitle: '有未提交的改动',
      branchConfirmIntro: '切换到 "{branch}" 将覆盖以下本地文件：',
      branchConfirmMore: '另有 {count} 个',
      branchConfirmStash: '储藏并切换',
      branchConfirmDiscard: '丢弃并切换',
      branchConfirmCancel: '取消',
      branchConfirmHint: '储藏可恢复（git stash pop）；丢弃将永久删除这些文件（包括未跟踪文件）。',
      branchSwitchError: '切换分支失败',
      goalStatusActive: '进行中',
      goalStatusCompleted: '已完成',
      goalStatusBlocked: '受阻',
      goalStarted: '开始于',
      goalElapsed: '已用时',
      goalEdit: '编辑',
      goalEditTitle: '编辑目标',
      goalClear: '清除目标',
      goalSaveFailed: '保存目标失败',
      goalTokens: '{used} tokens',
      goalTokensK: '{k}k tokens',
      durationSeconds: '{n}秒',
      durationMinutes: '{m}分{s}秒',
      durationHours: '{h}小时{m}分',
      commonTokens: '{used} tokens',
      commonLoading: '加载中…',
      commonClose: '关闭',
      commonCancel: '取消',
      commonSave: '保存',
      commonDone: '完成',
      commonEnable: '启用',
      commonDisable: '停用',
      commonRecommended: '推荐',
    },
    list: {
      title: '设备',
      subtitle: '连接到你账号的 jcode 设备。可以把工作发送到任何一台在线机器。',
      emptyTitle: '还没有设备',
      emptyBody: '在一台机器上运行 `jcode login`，把它连接到 jcode Cloud。',
      online: '在线',
      offline: '离线',
      lastSeen: '最近在线 {time}',
      neverSeen: '从未上线',
      loadErrorTitle: '无法加载设备',
      servicePrincipal: '设备与用户账号绑定——请以用户身份登录，而不是使用控制台服务令牌。',
      platformDesktop: '桌面端',
      platformCli: 'CLI',
      e2ee: '端到端加密',
      e2eeWithKeyGen: '端到端加密 · 密钥代数 {gen}',
    },
    welcome: {
      back: '设备',
      newSession: '新会话',
      composerPlaceholder: '向 jcode 提问…',
      send: '发送',
      mode: '模式',
      sessions: '会话',
      sessionCount_one: '{count} 个会话',
      sessionCount_other: '{count} 个会话',
      noSessions: '还没有会话——发送一条消息即可开始。',
      creating: '正在创建会话…',
      createSlow: '设备响应较慢——会话稍后出现。',
      untitled: '未命名会话',
      offlineBanner: '此设备已离线。重新连接前无法发送消息。',
      delete: '删除设备',
      deleteConfirm: '确定删除 {name} 吗？设备将退出登录并停止同步，会话历史保留在服务器上。',
      deleted: '已删除设备 {name}',
      sessionDelete: '删除会话',
      sessionDeleteRunning: '请先停止会话再删除',
      sessionDeleteConfirm: '确定从桌面端和云端删除“{name}”吗？',
      sessionDeleted: '已删除会话“{name}”',
      status: {
        idle: '空闲',
        running: '运行中',
      },
    },
    session: {
      back: '返回设备',
      thinking: '思考中',
      thinkingAria: '思考中…',
      you: '你',
      send: '发送',
      stop: '停止',
      composerPlaceholder: '给 jcode 发消息…',
      offlineBanner: '设备离线——重新连接前无法发送。',
      streamError: '实时流中断——正在重连…',
      reconnect: '重新连接',
      approve: '批准',
      approveAll: '始终允许',
      deny: '拒绝',
      toolDenied: '已拒绝',
      askUser: 'jcode 提了一个问题（在设备上回答）：',
      agentStarted: 'Agent 已开始',
      agentDone: 'Agent 已完成',
      agentStopped: '已被用户停止',
      agentFailed: 'Agent 失败：{message}',
      taskRunning: '会话运行中',
      taskIdle: '会话空闲',
      modeChanged: '模式已切换为 {mode}',
      modelChanged: '模型已切换为 {model}',
      sessionReset: '会话已重置',
      todoUpdated: 'Todos 已更新',
      goalUpdated: '目标已更新：{objective}',
      goalCleared: '目标已清除',
      subagentStarted: '子 agent {name} 已开始',
      subagentDone: '子 agent {name} 已完成',
      subagentFailed: '子 agent {name} 失败',
      sendFailed: '无法发送：{message}',
      deviceOffline: '设备已离线',
      emptyHistory: '此会话还没有事件。',
      source: {
        console: '控制台',
        mobile: '移动端',
        desktop: '桌面端',
        wechat: '微信',
        local: '本地',
      },
    },
    guide: {
      entry: '使用指南',
      title: 'jcode 设备使用指南',
      subtitle: '如何用 `jcode login` 接入一台机器，并从浏览器或手机 app 远程使用它。',
      back: '返回设备列表',
      shots: {
        devices: '云控制台中的设备列表',
        welcome: '设备页：发起新会话、浏览已有会话',
        session: '从设备实时推送的会话',
        offline: '设备离线时仍可查看历史',
        login: '手机 app 的登录界面',
      },
      what: {
        title: '什么是"设备"？',
        p1: '设备是一台运行 jcode（CLI 或桌面版）并通过 `jcode login` 登录到 jcode Cloud 的机器。接入后，你可以从云控制台或手机 app 远程查看和操作这台机器。',
        p2: '云端只做中转：你的机器主动向云端发起连接，无需开放入站端口或 VPN。会话始终在你的机器上运行并保存。',
      },
      quickstart: {
        title: '快速上手',
        p1: '在你要控制的机器上运行：',
        code1: 'jcode login',
        p2: 'CLI 会打印一个验证码和一个确认链接——在浏览器里确认登录。随后设备会自动连接，并出现在你的设备列表中。',
        p3: '默认登录 https://cloud.j-code.net。self-host 时传入你的云端地址——必须使用 https（仅 localhost 开发场景允许 http）：',
        code2: 'jcode login --cloud https://your-cloud.example.com',
      },
      remote: {
        title: '远程使用设备',
        p1: '打开设备列表，点进一台设备：可以发起新会话、实时跟进进行中的会话、停止运行、处理权限审批——和在机器本机上操作一致。',
        p2: '设备离线时仍可翻看会话历史，但发消息和审批会被禁用，直到设备重新上线。',
      },
      pairing: {
        title: '配对与端到端加密',
        p1: '会话内容端到端加密：云端只存密文和路由元数据，无法读取你的会话。新客户端（新浏览器或手机）必须先与设备配对，才能解密任何内容。',
        p2: '在浏览器或手机端发起配对，然后打开设备上的 jcode Desktop，进入「设置 → 云端」，核对客户端名称，并在 10 分钟内批准或拒绝。CLI 仍可用于自动化：',
        code1: 'jcode cloud pairings',
        code2: 'jcode cloud approve <pairing_id>',
        p3: '推荐在 Desktop 的「设置 → 云端」中审核。自动化场景可用 `pairings` 查看待处理请求，再用 `approve` 批准（拒绝对应 `jcode cloud deny <pairing_id>`）。',
      },
      keys: {
        title: '密钥与恢复',
        p1: '加密密钥（CEK）在你的第一台设备上生成，永不明文离开你的设备。请备份一次 24 词恢复短语并妥善保管：',
        code1: 'jcode cloud key show-phrase',
        p2: '如果所有设备都丢失，在新登录的设备上用短语恢复密钥：',
        code2: 'jcode cloud key recover',
        p3: '需要更换密钥时（已配对的客户端需重新配对）：',
        code3: 'jcode cloud rotate-key',
      },
      commands: {
        title: '常用命令',
        p1: '以下命令都在设备上运行：',
        rows: {
          login: '把本机登录到 jcode Cloud（设备码流程）。',
          loginStatus: '显示当前登录状态并退出。',
          logout: '退出登录：吊销设备令牌并清除本地凭据。',
          cloudStatus: '显示云端地址、设备 id、密钥代数和连通性。',
          pairings: '列出客户端发来的待批准配对请求。',
          approve: '批准一个配对请求（把加密后的密钥交给客户端）。',
          deny: '拒绝一个配对请求。',
          showPhrase: '显示加密密钥的 24 词恢复短语。',
          recover: '用恢复短语重建加密密钥。',
          rotateKey: '生成新密钥（key_gen+1）；已配对客户端需重新配对。',
        },
        e2eeNote: '端到端加密默认开启。需要临时关闭（明文上行，用于排查）时，在 `~/.jcode/config.json` 中设置 "cloud": { "e2ee": false } 并重启 `jcode web`。',
      },
    },
    pairing: {
      start: '配对此客户端',
      requests: {
        title: '配对请求',
        body: '此已批准客户端可以安全地批准其他浏览器或手机。',
        approve: '批准',
        deny: '拒绝',
        approvalLost: '此客户端已不再获批，请先重新配对。',
      },
      idle: {
        title: '尚未设置端到端加密',
        body: '请从当前客户端发起配对。请求会出现在 jcode Desktop 的「设置 → 云端」中；在那里批准之前，加密会话内容保持锁定。',
      },
      pending: {
        title: '等待设备上批准',
        body: '请打开设备上的 jcode Desktop，进入「设置 → 云端」，核对当前客户端，并在 10 分钟内批准或拒绝此请求。',
      },
      denied: {
        title: '配对被拒绝',
        body: '设备拒绝了此配对请求。如是误操作，请重新发起。',
      },
      expired: {
        title: '配对已过期',
        body: '配对请求未在 10 分钟内获得批准，请重新发起。',
      },
      gate: {
        title: '需要配对',
        body: '该设备已强制启用端到端加密。配对完成前，会话内容与控制不可用。',
      },
      error: {
        title: '配对失败',
        body: '配对过程中出现问题，请重试。',
      },
    },
    securityEyebrow: '设备登录',
    title: '授权设备',
    lede: 'jcode Desktop 正在请求登录此云端。输入 Desktop 中显示的验证码以继续。',
    safetyTitle: '仅批准由你发起的请求',
    enterTitle: '输入 Desktop 中的验证码',
    codeLabel: '设备验证码',
    codeHint: 'jcode Desktop 中显示的 8 位验证码，形如 XXXX-XXXX。',
    codeCell: '第 {n} 个字符，共 {total} 个',
    codeRequired: '请输入 jcode Desktop 显示的验证码。',
    continue: '继续',
    confirmTitle: '这是你的设备吗？',
    confirmBody: '仅当此验证码与 jcode Desktop 当前显示的登录请求一致时才批准。',
    approve: '批准',
    deny: '拒绝',
    approvedTitle: '设备已批准',
    approvedBody: '请返回 jcode Desktop，登录将自动完成。',
    deniedTitle: '设备已拒绝',
    deniedBody: '登录请求已被拒绝，jcode Desktop 将停止等待。',
    another: '授权另一台设备',
    unavailableTitle: '该登录请求已不可用',
    tryAnotherCode: '输入其他验证码',
    backToDevices: '返回设备列表',
    errorNotFound: '没有与该验证码匹配的待处理登录——它可能已过期。请从 jcode Desktop 重新发起登录。',
    errorAlreadyDecided: '该登录请求已被批准或拒绝。',
    errorGeneric: '无法授权设备，请重试。',
  },

  projectDetail: {
    promptRequired: '为 agent 描述任务。',
    sessionStarted: '会话已开始。',
    startRunFailed: '启动运行失败。',
    defaultModelUpdated: '默认模型已更新。',
    defaultModelFailed: '无法设置默认模型。',
    deliveryPolicyUpdated: 'Pull request 交付策略已更新。',
    deliveryPolicyFailed: '无法更新交付策略。',
    runnerProfileUpdated: '运行环境配置已更新。',
    runnerProfileFailed: '无法设置运行环境配置。',
    repoAdded: '仓库 “{name}” 已添加。',
    addRepoFailed: '添加仓库失败。',
    nameRequired: '名称为必填项。',
    repoUrlRequired: '仓库 URL 为必填项。',
    draftPrNeedsProviderUrl: '草稿 PR 需要提供方仓库 URL。',
    loadingProject: '加载项目…',
    loadFailedTitle: '无法加载项目',
    projects: '项目',
    cluster: 'Cluster',
    projectWorkspace: '项目工作区',
    addService: '添加服务',
    deleteService: '删除服务',
    deleteServiceAria: '删除服务 {name}',
    deleteServiceConfirm: '删除服务“{name}”？仍在执行的任务会先停止，随后永久删除该服务的全部任务、事件、产物、自动化和工作区资源。此操作无法撤销。',
    serviceDeleted: '服务“{name}”已删除。',
    deleteServiceFailed: '无法删除服务。',
    breadcrumb: '面包屑',
    backToWorkspace: '返回项目工作区',
    projectSettings: '项目设置',
    kanban: 'Agent Board',
    kanbanRetryTitle: '无法加载 Kanban 链接。请重试。',
    kanbanUnavailableRetry: 'Kanban 不可用 · 重试',
    demoTag: 'DEMO',
    noRepositoriesYet: '暂无服务',
    repositoriesCount_one: '{count} 个仓库',
    repositoriesCount_other: '{count} 个仓库',
    openProvider: '打开 {provider}',
    repoUrlUnresolved: '服务器无法解析此提供方仓库的浏览器 URL。',
    repositoryUnavailable: '仓库不可用',
    addRepoEmptyTitle: '添加服务以开始',
    addRepoEmptyManage: '服务会把项目连接到 Git 仓库，并作为运行的目标。',
    addRepoEmptyMember: '在可以派发运行之前，需要项目所有者添加服务。',
    firstServiceEyebrow: '项目初始化',
    firstServiceAction: '连接第一个仓库',
    firstServiceSetupTitle: '添加第一个服务',
    firstServiceSetupDescription: '选择一个仓库。连接后，它会成为任务和自动化的运行目标。',
    source: '来源',
    directCredential: '直接（你的凭据）',
    gitProvider: 'Git 提供方',
    pickRepository: '选择仓库',
    searchRepositories: '搜索仓库…',
    loadingRepositories: '加载仓库…',
    listReposFailed: '无法列出 {source} 仓库。',
    integrationSource: '集成',
    addRepoByUrlInstead: ' 请改为在下方通过 URL 添加仓库。',
    noRepositoriesMatch: '没有匹配的仓库。',
    private: '私有',
    orAddByUrl: '或通过 URL 添加',
    repositoryName: '仓库名称',
    repositoryUrl: '仓库 URL',
    addRepository: '添加仓库',
    memberNeedsIntegration: '添加服务前，请先连接并启用 GitHub、GitLab 或 Gitea 项目插件。',
    configureProjectPlugins: '配置项目插件',
    automationsMembersTitle: '自动化对项目成员可用',
    automationsMembersDesc: '你可以查看任务历史，但只有项目成员才能管理定时任务和提供方事件。',
    automationsNeedServiceTitle: '自动化需要一个服务',
    automationsNeedServiceDesc: '请先连接一个仓库；定时任务和提供方事件的范围限定于服务。',
  },

  plugins: {
    title: '插件', projectPlugin: '项目插件', intro: '每个项目只需连接一次提供方。健康且已启用的插件可供项目中的每个任务使用。',
    readOnly: '只有项目所有者或 Cluster 管理员可以更改插件连接。', loading: '正在加载插件…', loadError: '无法加载插件。',
    notConnected: '未连接', connect: '连接', connectError: '无法启动提供方连接。', summary: '{services} 个服务 · {automations} 个自动化',
    back: '返回插件', identity: '已连接身份', scopes: '已授予访问权限', noScopes: '当前未授予提供方访问权限。',
    resources: '资源', noResources: '尚未绑定项目资源。', automationSummary: '自动化', openAutomations: '打开自动化', audit: '连接审计',
    noAudit: '尚未记录审计事件。', reconnect: '重新连接', stableId: '稳定 ID：{id}', consentRecorded: '同意版本 {version} · {time}', unknown: '未知',
    resourcesLoadError: '无法列出提供方资源。', boundWorkspace: '绑定的工作区', selectWorkspace: '选择工作区…', workspaceSetupHint: '选择工作区会完成 JType 插件设置并启用它。',
    workspace: '工作区', columns: '{count} 列', private: '私有', public: '公开', defaultBranchUnknown: '默认分支未知', services: '关联服务',
    noServices: '没有服务绑定到此插件。', noAutomations: '没有自动化依赖此插件。', auditLoadError: '无法加载插件审计记录。', auditLoading: '正在加载审计记录…',
    impactLoading: '正在加载影响范围…', impactLoadError: '无法加载影响范围。', impactSummary: '{services} 个服务和 {automations} 个自动化将被永久删除。',
    forceUninstall: '仅当提供方 Webhook 清理失败时强制本地移除。这可能会留下外部 Webhook。',
    enable: '启用插件', disable: '停用插件', uninstall: '卸载插件', uninstallHint: '卸载会在完成外部清理后永久移除依赖的服务和自动化。', uninstallTitle: '卸载 {provider}？', uninstallConfirm: '此操作无法撤销。插件在本地移除后，外部 Webhook 清理可能仍会继续。', uninstallType: '输入 UNINSTALL 以确认', invalidProvider: '此提供方插件不存在。',
    consentTitle: '连接 {provider}', consentIntro: '继续前，请查看此连接将授予 jcode Cloud 的项目级访问权限。', consentScope: '提供方将请求此插件所需的代码、分支、合并请求、Issue、评论、检查、标签、发布和 Webhook 访问权限。', consentShared: '令牌会成为项目共享凭据，而非安装者的个人凭据。', consentTasks: '所有项目任务都会获得每个已启用的插件，包括此插件。', consentPersistence: '即使安装者离开项目，此连接仍会持续，直到断开或由提供方撤销。', consentPublic: '在公开仓库中，一条 @jcode 评论可启动获得项目全部已启用插件凭据的任务。', consentAcknowledge: '我理解并同意此项目级访问权限。', continueToProvider: '继续前往提供方',
    incompleteResponse: '提供方返回的连接响应不完整。',
    providerInstance: '提供方实例',
    configuredClusterInstance: 'Cluster 中配置的实例',
    requestedScopes: '请求的权限范围',
    githubChooseInstallation: '选择 GitHub App Installation',
    githubChooseInstallationHint: '同意前请选择一个 Installation 并检查其实际权限。此选择仅用于当前项目，系统不会自动跨项目复用。',
    githubInstallationsLoading: '正在加载 GitHub Installations…',
    githubInstallationsLoadError: '无法列出 GitHub Installations。',
    githubInstallationSummary: '{target} · {selection} 仓库',
    githubTarget: { organization: '组织', user: '用户' },
    githubSelection: { selected: '选定范围', all: '全部' },
    githubInstallationsEmpty: '没有找到你可管理的 GitHub App Installation。请在 GitHub 安装该 App 或调整仓库范围，然后重试。',
    githubActualPermissions: '{account} 的实际权限',
    githubPermissionsAcknowledge: '我已检查这些 GitHub App 实际权限，并接受上述项目级凭据风险。',
    githubConnectInstallation: '连接此 Installation',
    jtypeApprove: '在 JType 中批准',
    jtypeApproveHint: '使用验证码 <code>{code}</code>。此对话框会持续检查，直到 JType 确认授权。',
    jtypeOpenConsent: '打开 JType 同意页面',
    jtypeStatusLoadError: '无法检查 JType 连接状态。',
    connectionStatusLabel: '状态：{status}',
    connectionStatus: { pending: '等待批准', complete: '已完成', expired: '已过期', denied: '已拒绝', unsupported: '不支持', checkFailed: '无法检查状态' },
    coarseScope: {
      gitlab: 'GitLab 的粗粒度 api scope 可能允许比本插件通常所需范围更广的 API 读写操作，包括你的外部角色可修改的仓库设置。jcode 没有能够从技术上阻止所有破坏性 API 调用的命令白名单。',
      gitea: '根据实例版本和你的外部角色，Gitea 的粗粒度 write:repository scope 可能允许修改仓库设置以及执行超出常规任务流程的破坏性操作。jcode 没有命令白名单。',
      jtype: 'JType full scope 允许对所选云工作区执行所有受支持的读写操作，并不仅限于 Kanban 触发。',
    },
    healthError: {
      jtypeStartFailed: '无法启动 JType 设备授权。',
      webhookCleanupFailed: '提供方 Webhook 清理失败。请重试卸载，或明确强制本地移除并接受可能遗留外部 Webhook。',
      runtimeCleanupFailed: '运行时清理失败。请在 Cluster 恢复健康后重试卸载。',
      oauthRefreshFailed: 'OAuth 访问权限已过期且刷新失败，请重新连接此插件。',
      providerConfigChanged: 'Cluster 提供方配置已更改，请重新连接此项目插件。',
    },
    apiError: {
      githubAppNotConfigured: 'GitHub App 尚未完整配置。请让 Cluster 管理员填写 App ID、私钥和 Webhook Secret。',
      githubIdentityRequired: '请使用能够管理此 App Installation 的 GitHub 账号登录。',
      githubInstallationForbidden: '当前 GitHub 账号无法管理所选 App Installation。',
      githubAppError: 'GitHub 无法验证所选 App Installation，请重试。',
      consentScopeChanged: 'GitHub App 权限已发生变化，请重新检查当前权限并同意。',
      providerNotConfigured: '此提供方插件尚未在 Cluster 中配置或启用。',
      credentialUnavailable: '插件凭据不可用，请重新连接插件。',
      reconnectRequired: '插件配置已更改或授权已过期，请重新连接插件。',
      connectExpired: '连接请求已过期，请重新开始连接。',
      workspaceUnavailable: '当前授权无法访问所选 JType 工作区。',
      workspaceRequired: '启用此插件前，请先选择 JType 工作区。',
      webhookCleanupFailed: '提供方 Webhook 清理失败。请重试卸载，或明确强制本地移除。',
      runtimeCleanupFailed: '运行时清理失败，请在 Cluster 恢复健康后重试。',
      connectUnsupported: '暂不支持此提供方的连接流程。',
      encryptionUnavailable: 'Cluster 加密密钥尚未配置，请联系 Cluster 管理员。',
      consentRequired: '连接前请检查并同意当前项目插件授权说明。',
      providerUnavailable: '提供方无法完成此请求。请检查其可用性和权限后重试。',
      generic: '无法完成插件操作，请重试。',
    },
    auditEvent: {
      consent_accepted: '已同意授权', connected: '已连接', reconnected: '已重新连接', reconnect_started: '已开始重新连接',
      configuration_changed: '配置已更改', uninstall_cleanup_failed: '卸载清理失败', uninstalled: '已卸载', force_uninstalled: '已强制卸载',
    },
    status: { not_connected: '未连接', connecting: '连接中', enabled: '已启用', disabled: '已停用', action_required: '需要操作', uninstalling: '卸载中', error: '错误' },
    trigger: { scm: 'SCM 事件', kanban: 'Kanban 列', cron: '定时任务' },
    systemActor: '系统',
  },

  automationEditor: {
    loading: '正在加载自动化…', loadError: '无法加载自动化。', eyebrow: '仓库自动化', createTitle: '创建自动化', editTitle: '编辑自动化',
    subtitle: '为此仓库绑定一个强类型触发器。', viewerWarning: '查看者可以检查配置，但不能保存自动化。',
    task: '任务', name: '名称', service: '仓库', selectService: '选择仓库…', serviceUnavailable: '仓库不可用',
    model: '模型', selectModel: '选择模型…', effort: '推理强度', effortAuto: '自动', effortLow: '低', effortMedium: '中', effortHigh: '高',
    effortHint: '此模型声明支持推理强度设置。', promptTemplate: '提示词模板',
    enabled: '已启用', ignoreJcode: '忽略由 jcode 创建的事件', trigger: '触发器', scm: 'SCM', cron: 'Cron',
    selectGitService: '请连接一个 GitHub、GitLab 或 Gitea 仓库。', capabilitiesLoadError: '无法加载提供方能力。',
    branchFilter: '分支筛选', branchPlaceholder: 'main 或 feature/*', branchHint: '适用于包含分支信息的 Push、PR 和 Check 事件。',
    pathPattern: '路径模式', pathHint: '仅当所有选中事件均为 push.updated 时可用。',
    conclusion: 'CI 结果', conclusionHint: '仅当所有选中事件均为 check.completed 时可用。',
    events: '事件', moreEvents: '更多事件', thisProvider: '当前提供方', eventUnavailable: '{provider}{version} 不支持此事件。',
    cronExpression: 'Cron 表达式', cronHint: '使用五段式 Cron 表达式；服务器会强制执行最小时间间隔。',
    outputMode: '输出方式', outputRun: '直接创建 Run', outputCard: '先创建 jtype Card，再由 Agent Board 执行',
    outputHint: 'Card 输出会保留 jtype 工作项，并复用标准的看板受理与回写闭环。',
    openBoardSettings: '打开 Agent Board 设置',
    outputCardUnavailable: '请先连接健康的 Agent Board，再选择 Card 输出。',
    create: '创建自动化', save: '保存自动化',
    review: {
      eyebrow: 'GitHub 代码评审', title: '评审 Pull Request', subtitle: '无需让团队学习新流程，即可启用实用的 GitHub 原生评审。',
      defaultName: 'Pull Request 评审', setup: '评审设置',
      automaticTitle: '默认自动评审', automaticBody: 'Pull Request 准备好后，App 会自动评审；后续每次提交新代码也会再次评审。',
      repeatTitle: '直接从 GitHub 重复评审', repeatBody: '将此命令粘贴到任意 Pull Request 评论中。GitHub 的 @ 自动补全可能不显示自定义 App，但完整命令可以正常触发。',
      focus: '评审关注点（可选）', focusPlaceholder: '例如：特别关注授权边界。', focusHint: '评审器始终会检查正确性、安全性、可靠性、数据丢失和回归。',
      when: '何时评审', readyTitle: '已准备好的 Pull Request', readyBody: '评审新建的 Pull Request，以及从草稿转为准备好的 Pull Request。',
      updatesTitle: '有新提交时', updatesBody: 'Pull Request 的最新提交发生变化时重新评审。',
      draftsTitle: '包含草稿', draftsBody: '通常保持关闭，让作者先完成自己的第一轮检查。',
      create: '开启评审', save: '保存评审设置',
    },
    validation: {
      noPermission: '你没有编辑自动化的权限。',
      required: '名称、仓库、模型和任务提示词均为必填项。',
      eventRequired: '请至少选择一个该仓库提供方支持的事件。',
      cronRequired: 'Cron 表达式为必填项。',
      cardOutputUnavailable: 'Card 输出需要健康的 Agent Board 策略。',
    },
    apiError: {
      overlap: '此仓库的另一个自动化已经使用了所选 SCM 事件中的至少一个。',
      webhook: '自动化已保存，但无法同步提供方 Webhook。请检查插件连接后重试。',
      pluginUnavailable: '所选仓库连接不可用，或不支持此触发器。',
      modelUnavailable: '所选模型已不再对本账号可用，请选择其他模型。',
      modelRequired: '请选择一个已授权给本账号的模型。',
      effortUnsupported: '所选模型不支持推理强度，请使用“自动”或选择推理模型。',
      generic: '无法保存自动化，请重试。',
    },
  },

  automationExecutions: {
    loading: '正在加载自动化…', loadError: '无法加载自动化。', back: '返回自动化列表',
    cardOutput: 'Card 输出', runOutput: '直接 Run 输出', runNow: '立即运行',
    runNowError: '本次执行未能受理；重试会继续使用同一个幂等键。',
    history: '执行历史', loadingHistory: '正在加载执行历史…', historyError: '无法加载执行历史。',
    empty: '还没有执行记录。', loadMore: '加载更早的执行', select: '选择一条执行记录查看详情。',
    selected: '选中的执行', execution: '执行', trigger: '触发来源', kind: '类型',
    requested: '请求者', accountable: '责任人', notApplicable: '不适用', unattributed: '未归因',
    output: '输出', expected: '预期', cardThenRun: 'jtype Card → 看板 Run', directRun: '直接 Run',
    actual: '实际结果', writeback: '回写', usage: '用量', usageUnavailable: '暂不可用',
    filter: { all: '全部', blocked: '受阻', running: '运行中', terminal: '已结束' },
    state: {
      accepted: '已受理', ignored: '已忽略', duplicate: '重复',
      superseded: '已取代', blocked: '受阻', queued: '排队中',
      running: '运行中', terminal: '已结束',
    },
    outcome: { succeeded: '成功', failed: '失败', canceled: '已取消' },
    repair: {
      project_owner: '项目所有者可以修复此依赖。',
      repository_owner: '仓库所有者可以修复此依赖。',
      cluster_admin: '需要集群管理员修复此依赖。',
      requester: '需要请求者修复此依赖。',
    },
    title: {
      blocked: '在生成输出前受阻', ignored: '触发已按规则忽略',
      card: 'Card 输出', run: 'Run 输出',
    },
  },

  projectAutomations: {
    eyebrow: '仓库自动化', title: '自动化', subtitle: '为此仓库创建 SCM 和定时任务。Agent Board 从仓库标题区域配置。',
    loading: '正在加载自动化…', loadError: '无法加载自动化。', new: '新建自动化', noServices: '创建自动化前请先连接仓库。',
    filters: '自动化筛选', all: '全部', empty: '当前视图中没有匹配的自动化。', edit: '编辑', delete: '删除',
    back: '返回自动化', newTitle: '新建自动化', editTitle: '编辑自动化', name: '名称', triggerLabel: '触发器类型',
    cron: 'Cron 表达式', action: 'SCM 事件', column: '触发列', prompt: '任务说明', incomplete: '保存前请填写所有必填项。',
    create: '创建自动化', save: '保存更改', trigger: { scm: 'SCM 事件', kanban: 'Kanban 列', cron: '定时任务' },
    enabled: '已启用', disabled: '已停用', toggleLabel: '{name}：{status}',
    review: { turnOn: '评审 Pull Request', manage: '评审设置', rowSummary: '由 GitHub App 在变更行上发布高置信度问题。', native: 'GitHub 原生评审' },
    error: {
      modelUnavailable: '收到此事件时无法选择可用模型。请为账号授权模型；如果有多个可用模型，请设置仓库默认模型。下一次成功触发后会自动清除此历史错误。',
      modelNotSelected: '有多个可用模型，但此仓库没有默认模型。请在仓库设置中选择一个。',
      modelNotConfigured: '此账号没有获授权的模型。请让 Cluster 管理员授权一个模型。',
      modelTemporary: '由于临时内部错误，无法读取模型配置。请重新触发。',
      triggerUnavailable: '此自动化的触发配置不可用，请重新保存自动化。',
      serviceUnavailable: '此自动化关联的仓库不可用。',
      repositoryUnavailable: '此仓库连接不可用。请重新连接提供方。',
      runCreateFailed: '事件已匹配，但无法创建自动化任务。',
      invalidCron: 'Cron 表达式无效：{expression}',
      dispatchFailed: '定时自动化无法创建任务。',
      webhookReconcileFailed: '无法同步 SCM Webhook。请检查插件凭据和提供方 Webhook 权限，然后重新保存自动化。',
    },
  },

  projectSettings: {
    navGeneral: '通用',
    navMembers: '成员',
    navPlugins: '插件',
    navModels: '模型访问',
    navApiKeys: 'API 密钥',
    envInvalidName: '“{key}” 不是有效的环境变量名称。',
    envReserved: '“{key}” 由编排器保留，无法设置。',
    projectUpdated: '项目 “{name}” 已更新。',
    updateFailed: '更新项目失败。',
    projectDeleted: '项目 “{name}” 已删除。',
    deleteFailed: '删除项目失败。',
    eyebrow: '项目管理',
    title: '设置',
    subtitle: '管理项目容器。仓库行为的范围仍限定于各个服务。',
    navAria: '项目设置分区',
    generalDesc: '项目标识和执行护栏。',
    projectName: '项目名称',
    projectNameHintPage: '仓库分支和 Git 模式按服务配置。',
    executionGuardrails: '执行护栏',
    guardrailBlankHint: '将限制留空以继承 Cluster 默认值。',
    maxConcurrent: '最大并发运行',
    clusterDefaultPlaceholder: 'Cluster 默认值',
    runTimeout: '运行超时（秒）',
    injectedEnv: '注入的环境变量',
    injectedEnvHintPage: '合并到每次运行中。系统变量为保留项。',
    removeVariable: '移除变量',
    addVariable: '添加变量',
    membersTitle: '成员与权限',
    membersDesc: '选择谁可以查看、运行和管理此项目。',
    pluginsTitle: '插件',
    pluginsDesc: '项目共享的源代码管理与看板连接。',
    modelsDesc: '当前可供此项目会话使用的模型。',
    apiKeysTitle: '项目 API 密钥',
    apiKeysDesc: '用于 API 触发自动化的可撤销凭据。',
    dangerTitle: '危险区域',
    dangerDesc: '永久性、破坏性的项目操作。',
    deleteProject: '删除项目',
    deleteHintPage: '永久删除此项目及其所有运行、事件和产物。',
    deleteForGood: '永久删除？',
    savebarHint: '项目设置独立于服务设置保存。',
    saveChanges: '保存更改',
    loadingModelAccess: '加载模型访问…',
    modelAccessLoadError: '无法加载模型访问。请从项目工作区重试。',
    noModelConfigured: '此项目未配置模型。请联系 Cluster 管理员授权一个。',
    granted: '已授权',
    envFallbackActive: 'Cluster 环境模型回退已启用。',
    models: {
      ownedTitle: '项目模型提供方',
      ownedDescription: '为此项目接入自有的提供方，并选择可运行的模型。',
      addProvider: '添加提供方',
      providersSummary: '{providers} 个提供方 · {models} 个模型',
      noProviders: '尚无项目模型提供方。',
      noProvidersHint: '添加提供方，为此项目配置专属模型。',
      enableAria: '启用 {name}',
      disableAria: '停用 {name}',
      editModelAria: '编辑 {name}',
      deleteModelAria: '移除 {name}',
      removeModelConfirm: '移除 {name}？',
      modelRemoved: '模型已移除。',
      removeModelError: '无法移除该模型。',
      updateModelError: '无法更新该模型。',
      clearHeadersAction: '移除已配置的 Header',
      clearHeadersPending: '保存后将移除已配置的 Header · 点击撤销',
      editDialogTitle: '编辑模型 · {name}',
      saveModel: '保存模型',
      modelSaved: '模型已保存。',
      saveModelError: '无法保存该模型。',
      availableTitle: '可用模型',
      defaultTitle: '项目默认模型',
      defaultDescription: '当自动化或服务未选择更具体的模型时使用。',
      noDefault: '不设置项目默认模型',
      availableOwnerHint: '此项目可运行的全部模型 — 包含自有模型以及 Cluster 管理员授予的模型。',
      availableMemberHint: 'Cluster 管理员或项目所有者已为此项目提供的模型。',
    },
    name: '名称',
    guardrails: '护栏',
    apiKeyCreated: 'API 密钥 “{name}” 已创建。',
    apiKeyCreateFailed: '无法创建 API 密钥。',
    apiKeyRevoked: 'API 密钥已撤销。',
    apiKeyRevokeFailed: '无法撤销 API 密钥。',
    apiKeyIntro1: '项目范围的密钥以 ',
    apiKeyIntro2: ' 的身份认证，只能触发运行并读取此项目 — 绝不能访问其他项目、此项目的设置或成员，也绝不能访问 Cluster 管理员界面。请将它用于外部/CI 自动化，而不是使用 Cluster 范围的控制台令牌。',
    apiKeysEmpty: '还没有 API 密钥 — 在下方创建一个。',
    apiKeyNameHint: '帮助你以后区分密钥 — 请选择有辨识度的名称，例如将使用它的 CI 作业。',
    createKey: '创建密钥',
    apiKeyRevealTitle: '“{name}” 已创建',
    apiKeyRevealHint: '仅显示一次 — 请立即复制。它无法再次显示；如果你丢失了它，请撤销此密钥并创建一个新的。',
    statusRevoked: '已撤销',
    statusActive: '活跃',
    createdAt: '创建于 {time}',
    lastUsed: ' · 上次使用 {time}',
    neverUsed: ' · 从未使用',
    revoke: '撤销',
  },

  projectWorkspace: {
    railServicesAria: '项目服务',
    projectEyebrow: '项目',
    serviceCount_one: '{count} 个服务',
    serviceCount_other: '{count} 个服务',
    servicesHeading: '服务',
    noServiceConnected: '尚未连接服务。',
    workspaceAria: '{projectName} 工作区',
    tabsAria: '项目工作区分区',
    tabTasks: '任务',
    tabAutomations: '自动化',
    tabServiceSettings: '服务设置',
  },

  taskComposer: {
    eyebrow: '新建任务',
    heading: '在 {name} 中开始会话',
    isolation: '在隔离的工作区中运行',
    messageAria: '消息',
    placeholder: '描述要完成的工作…',
    permissionModeAria: '权限模式',
    permissionModeTitle: '完全访问会自动批准 agent；操作前询问会在时间线中暂停以等待你的批准。',
    fullAccess: '完全访问',
    askBeforeActions: '操作前询问',
    session: '会话',
    modelAria: '模型',
    serviceDefault: 'Repository 默认',
    serviceDefaultWithModel: 'Repository 默认 · {model}',
    branchAria: '基准分支',
    branchDefault: '默认',
	branchLoading: '正在加载分支…',
    branchUnavailable: '无法刷新分支。请修复 Plugin 连接后重试。',
    effortAria: '推理强度',
    effortAuto: '推理 · 自动',
    effortLow: '推理 · 低',
    effortMedium: '推理 · 中',
    effortHigh: '推理 · 高',
    add: '添加',
    addMenu: '添加到任务',
    goalMode: 'Goal 模式',
    goalPlaceholder: '描述需要持续推进的目标…',
    goalModeHint: '下一项任务将作为持续运行的 Goal 启动。',
    disableGoalMode: '关闭 Goal 模式',
    attachments: '附件',
    addAttachments: '添加附件',
    removeAttachment: '移除 {name}',
    attachmentTooMany: '最多可添加 {max} 个附件。',
    attachmentTooLarge: '{name} 超过 25 MiB。',
    attachmentTotalTooLarge: '每次运行的附件总大小不能超过 {max} MiB。',
    attachmentUploadFailed: '附件上传失败。',
    send: '发送',
  },


  settingsPanel: {
    emptyTitle: '设置需要一个 Repository',
    emptyDescription: '在配置其模型策略之前，请先连接一个仓库。',
    eyebrow: 'Repository 设置',
    description: '此 Repository 的执行策略；提供方连接需单独管理。',
    source: '来源',
    provider: '提供方',
    defaultBranch: '默认分支',
    gitMode: 'Git 模式',
    gitModeDraftPr: 'Pull request',
    gitModePullRequest: 'Pull request',
    gitModeReadOnly: '只读',
    deliveryPolicyEyebrow: '交付策略',
    deliveryPolicyTitle: '评审就绪状态',
    deliveryPolicyDescription: '生命周期感知模式会让单次任务直接进入待评审状态，多轮会话则保持草稿直到 Finish。切换可能通知评审者并触发仓库 workflow。',
    deliveryPolicyAria: 'Pull request 完成策略',
    lifecycleAware: '生命周期感知',
    alwaysDraft: '始终保持草稿',
    modelPolicyEyebrow: '模型策略',
    modelPolicyTitle: 'Repository 默认模型',
    modelPolicyDescription: '仅当任务编辑器将每次运行的选择保持为“Repository 默认”时才会使用。',
    modelsLoading: '正在加载账号模型权限…',
    modelsUnverified: '无法验证此账号的模型权限。在模型目录可用之前，请勿更改默认值。',
    retryModelCheck: '重试模型检查',
    defaultModelAria: '此仓库的默认模型',
    noDefault: '无默认',
    noModelGranted: '尚未向此账号授权模型。Cluster 管理员必须先授权一个，才能选择 Repository 默认模型。',
	runtimePolicyEyebrow: '运行时策略',
	runtimePolicyTitle: 'Runner 环境',
	runtimePolicyDescription: '为此 Repository 的每次 Run 选择由管理员维护的不可变工具链环境。',
	runnerProfileAria: '此仓库的 Runner 环境',
	runtimeProfilesUnavailable: '无法加载运行环境列表，当前 Repository 设置保持不变。',
  },

  webhook: {
    errSync: '无法同步提供方 Webhook。请重试或联系 Cluster 管理员。',
    eyebrowReview: 'PR 审查 Webhook',
    unavailableTitle: '提供方事件需要由提供方支持的仓库',
    pathOrUrlNote: '是路径或原始 URL，因此无法接收拉取请求或合并请求的评论事件。',
    readonlyTitle: '自动化对查看者为只读',
    readonlyBody: '项目成员可以连接 {provider} 并同步此仓库的审查 Webhook。',
    oauthNotConfiguredTitle: '{provider} OAuth 尚未在此 Cluster 中配置',
    oauthNotConfiguredBody: '请联系 Cluster 管理员配置 {provider} OAuth 和 Webhook 接收器。不会使用任何回退凭据。',
    serviceTitle: '已登录的项目成员必须授权 {provider}',
    serviceBody: '控制台令牌会话没有个人 OAuth 身份。请使用项目成员账户登录以同步此 Webhook。',
    eyebrowProvider: '提供方 Webhook',
    connectTitle: '连接 {provider} 以使用 PR 审查命令',
    connectBodyPre: '连接用于管理',
    connectBodyPost: ' 的账户。jcode 会为此仓库请求 OAuth 权限；它绝不会要求你在此粘贴个人访问令牌。',
    connectCta: '使用 OAuth 连接 {provider}',
    readyTitle: '{provider} PR 审查命令',
    readyBodyPre: '同步会为',
    readyBodyMid: ' 注册提供方的评论 Webhook，使用你的 {provider} OAuth 账户。协作者随后可以使用 ',
    readyBodyPost: ' 开始审查。仓库变更时可以安全地再次运行。',
    oauthConnected: 'OAuth 已连接。',
    synchronizing: '正在同步 Webhook…',
    setupReady: 'Webhook 设置已就绪。',
    syncedTo: 'Webhook 已同步到',
    syncButton: '同步 {provider} Webhook',
    reconnectOauth: '重新连接 OAuth',
  },

  runActivity: {
    eyebrow: '活动',
    title: '最近任务',
    filtersAria: '筛选最近任务',
    filterAll: '全部',
    filterSessions: '会话',
    filterReviews: '审查',
    loadingTasks: '加载任务…',
    errorTitle: '无法加载任务',
    emptyTitleAll: '暂无任务',
    emptyTitleFiltered: '此 Repository 没有 {filter}',
    emptyDescDispatch: '使用上方的编辑器派发你的第一个任务。',
    emptyDescNone: '此项目中尚未派发任何任务。',
    emptyDescFiltered: '尝试其他筛选或选择其他 Repository。',
    runAria: '{kind}：{summary} — {status}',
    retryTitle: '重试较早的运行',
    retryBadge: '重试',
  },

  projectSettingsAction: {
    label: '项目设置',
  },

  codeReviewsPage: {
    eyebrow: '独立工作流',
    title: 'Code reviews',
    description: '集中查看所有 Repository 的 Review Run，并与开发任务保持独立。',
    createEyebrow: '新 Review',
    createTitle: '发起 Code review',
    createDescription: '选择 Repository，以及由已完成 Cloud 任务创建的 Pull request。',
    loadingSources: '正在加载可 Review 的 Pull request…',
    sourcesError: '无法加载可 Review 的 Pull request。',
    noRepositories: '当前账号没有可用的 Repository。',
    connectRepository: '检查 Git 账号授权',
    repositoryLabel: 'Repository',
    pullRequestLabel: 'Pull request',
    noReviewablePr: '当前没有可 Review 的 Cloud Pull request。',
    noReviewablePrDescription: '先从 Repository 任务创建 Pull request，然后返回这里。',
    openWorkHome: '打开 Work Home',
    openPullRequest: '打开 Pull request',
    createAction: '创建 Code review',
    createSuccess: 'Code review 已开始。',
    createError: '无法开始 Code review。',
    emptyTitle: '暂无 Code review',
    emptyDescription: '所有 Repository 的 Review Run 会集中显示在这里。',
  },
  accountHeader: {
    location: '工作区位置',
    account: '账号',
    menu: '账号菜单',
    codeReviews: '代码审查',
    settings: '账号设置',
    clusterSettings: 'Cluster 设置',
    admin: '管理员',
    signOut: '退出登录',
  },
  accountSettings: {
    back: '返回工作台',
    eyebrow: '账号',
    title: '账号设置',
    description: '你的个人资料、模型授权、关联的 Git 账号、用量和偏好设置会应用于每个 Repository 和 jcode Desktop。',
    tabsAria: '账号设置分区',
    profileTab: '个人资料',
    gitAccountsTab: 'Git 账号',
    modelsTab: '模型',
    usageTab: '用量',
    preferencesTab: '偏好设置',
    profileTitle: '账号资料',
    profileDescription: '这是执行 Repository 任务和拥有对话时使用的身份。',
    displayName: '显示名称',
    accountId: '账号 ID',
    role: '角色',
    clusterAdministrator: 'Cluster 管理员',
    member: '成员',
    executionIdentity: '执行身份',
    repositoryOwnerDefault: 'Repository 默认 owner',
    currentAccount: '当前账号',
    sessionAccount: '会话账号',
    gitAccountsTitle: 'Git 账号',
    gitAccountsDescription: '这些已关联账号可见的 Repository 会直接出现在 Work Home 的上下文选择器中。',
    repositoryAccessUnavailable: '此账号当前无法访问 Repository。',
    connected: '已连接到此账号',
    reauthorize: '重新授权 {provider}',
    linkProvider: '关联 {provider}',
    authorizeRepositories: '为此账号授权 Repository',
    checkingRepositoryAccess: '正在检查 Repository 访问权限…',
    repositoryAccessUnavailableTitle: 'Repository 访问不可用',
    modelsTitle: '模型与提供方',
    modelsDescription: '配置个人提供方，选择用于任务的模型。',
    loadingModels: '正在加载账号模型…',
    modelAccessUnavailable: '模型授权不可用',
    noModels: '你的账号尚未获得模型授权。请联系 Cluster 管理员。',
    modelAuthorized: '账号已授权',
    manageAuthorizations: '在 Cluster 设置中管理账号授权',
    preferencesTitle: '偏好设置',
    preferencesDescription: '在支持的范围内，Cloud 和 Desktop 使用相同的产品语言和视觉偏好。',
    language: '语言',
    languageDescription: '更改界面语言。',
    appearance: '外观',
    appearanceDescription: '使用浅色或深色主题。',
  },
  repositories: {
    openRepository: '打开仓库 {name}',
    toggleConversations: '展开或收起 {name} 的会话',
    conversationSection: '会话',
    navigationUnavailable: '此仓库不可用。请检查 Git 账号授权，或选择其他仓库。',
    remoteUnavailable: '此远程设备不可用。请重新连接或选择其他设备。',

    eyebrow: '你的代码',
    title: 'Repositories',
    description: '一个 Repository 对应一个 Agent 工作区，并拥有独立的 Board、任务、设置和 Code reviews。',
    composerEyebrow: '账号工作区', composerTitle: '接下来想写什么？',
    composerDescription: '选择当前账号可访问的任意仓库，直接开始对话或任务。',
    remoteComposerDescription: '在在线 jcode 设备上使用相同的对话界面继续工作。',
    contextAria: 'Repository 或 Remote 上下文 {context}',
    repositoryFallback: 'Repository',
    remoteBack: '返回 Repositories',
    remoteConnection: '远程连接',
    remoteChooseDevice: '选择在线 jcode 设备',
    onlineDevices: '在线设备',
    jcodeDevice: 'jcode 设备',
    online: '在线',
    connectNewDevice: '连接新设备',
    connectNewDeviceDescription: '运行 jcode login 并完成加密配对',
    pickerSearchAria: '搜索 Repositories',
    pickerSearchPlaceholder: '搜索 Repositories…',
    gitRepositories: 'Git 仓库',
    pickerSearchError: 'Repository 搜索失败，请修改关键词或重试。',
    pickerNoMatch: '没有与“{query}”匹配的 Repository。',
    remoteConnectionAria: '远程连接，{count} 台在线',
    remoteOnlineCount: '{count} 台 jcode 设备在线',
    searchingRepositories: '正在搜索 Repositories',
    conversationRailAria: '对话',
    conversationRailWorkHome: '工作首页',
    conversationRailNew: '新对话',
    conversationRailSearchAria: '搜索对话',
    conversationRailSearchPlaceholder: '搜索对话…',
    conversationRailByRepository: '最近仓库',
    conversationRailCollapse: '收起对话栏',
    conversationRailExpand: '展开对话栏',
    conversationRailEmptyTitle: '暂无对话',
    conversationRailEmptyDescription: '开始一个任务来创建第一条对话。',
    conversationRailNoMatch: '没有匹配的对话。',
    conversationRailRepositoryUnavailable: 'Repository 不可用',
    workspaceTasks: '任务',
    workspaceBoard: '看板',
    workspaceReviews: '代码审查',
    workspaceAutomations: '自动化',
    workspaceUsage: '用量',
    workspaceSettings: '设置',
    cloudRunner: '云端 Runner',
    noTasksTitle: '此 Repository 暂无任务',
    noTasksDescription: '在上方描述任务以开始第一个对话。',
    boardDescription: '连接已有 Board，让 Card 启动此 Repository 的 Agent。',
    reviewsDescription: '此 Repository 的独立代码审查 Run。',
    reviewsEmptyDescription: '创建独立审查，不与实现任务混在一起。',
    boardNotConnected: '尚未连接 Board',
    boardNotConnectedDescription: '准备好后连接已有 Board；Repository 工作区现在已经可用。',
    boardWorkflowAria: '默认 Agent Board 流程',
    boardBacklog: '待处理',
    boardBacklogDescription: '等待处理的 Card',
    boardAgentQueue: 'Agent 队列',
    boardAgentQueueDescription: '会启动 jcode 的 Card',
    boardDoneOptional: '完成（可选）',
    boardDoneDescription: '成功完成的结果',
    attachmentsAfterConversation: '此 Repository 建立活动对话后即可添加附件。',
    modeCeilingHint: 'Cloud 任务支持逐次确认、规划和自动模式。',
    baseBranchAria: '基础分支 {branch}',
    unavailable: '不可用',
    loadingBranches: '正在加载分支…',
    branchUnavailable: '分支不可用',
    startingRepositoryTask: '正在启动 Repository 任务…',
    branchesUnavailable: 'Repository 分支不可用。',
    noToolModel: '账号授权的模型都不支持 Agent 工具调用。',
    remoteSetup: 'Remote 设置',
    deviceOffline: '此设备已离线。请在设备上打开 jcode 后重试。',
    startingConversation: '正在开始新对话',
    deviceSlow: '设备响应时间比预期更长…',
    creatingOnDevice: '正在设备上创建…',
    taskAria: '描述任务', taskPlaceholder: '描述一个任务…', repositoryAria: 'Repository',
    accountLoading: '正在加载仓库…', chooseAccountRepository: '选择仓库',
    modelsLoading: '正在加载模型…', modelRequired: '选择模型', startTask: '开始任务',
    startFailed: '无法开始任务。', accountLoadError: '无法加载账号仓库，请重新连接代码托管账号后重试。',
    linkAccount: '连接 Git 提供商账号后即可选择仓库。', reviewGitAccountAccess: '检查 Git 账号授权',
    authorizeModel: '请让管理员为你的账号授权一个模型。', reviewModelAccess: '检查模型授权',
    detailsTitle: 'Repository 详情', detailsDescription: '打开已经使用过的 Repository，查看设置、Agent Board 和任务历史。',
    noDetails: '开始第一个任务后，这里会出现 Repository 详情；无需预先关联。',
    connect: '连接 Repository',
    preparing: '正在准备 Repository 工作区…',
    prepareError: '无法准备 Repository 工作区',
    connectionsTitle: '提供商账号',
    connectionsDescription: '管理账号提供商和 JType 访问；Repository 无需单独关联。',
    chooseRepository: '选择 Repository',
    loading: '正在加载 Repositories…',
    loadError: '无法加载 Repositories',
    emptyEyebrow: '从代码开始',
    emptyTitle: '连接第一个 Repository',
    emptyBody: '选择一个 Repository 来创建专属的 Agent 工作区。',
    listTitle: '已连接的 Repositories',
    visible: '个可见',
    search: '搜索 Repositories',
    searchPlaceholder: '搜索 owner 或 repository…',
    noMatch: '没有匹配的 Repository。',
    details: 'Repository 详情',
    open: '打开',
    codeReviews: '代码审查',
    loadingOne: '正在加载 Repository…',
    loadOneError: '无法加载 Repository',
    railAria: 'Repositories',
    noneConnected: '尚未连接 Repository。',
    workspaceAria: '{repositoryName} Repository 工作区',
    tabsAria: 'Repository 工作区分区',
    tabSettings: 'Repository 设置',
    connection: '提供方连接',
    connectionsIntro: '每个提供方只需为你的 Repositories 连接一次；健康的连接可供 Repository 任务使用。',
    connectionsReadOnly: '只有 Repository owner 或 Cluster 管理员可以更改提供方连接。',
    connectionSummary: '{repositories} 个 Repositories · {automations} 个自动化',
    providerRequired: '选择 Repository 前，请先连接并启用 GitHub、GitLab 或 Gitea 提供方。',
    configureConnections: '配置提供方连接',
    disconnect: '断开 Repository',
    disconnectAria: '断开 Repository {name}',
    disconnectConfirm: '断开“{name}”？系统会先停止活动任务，然后永久删除该 Repository 的 Run、事件、产物、自动化和工作区资源。此操作无法撤销。',
    disconnected: '已断开 Repository“{name}”。',
    disconnectFailed: '无法断开 Repository。',
    consentIntro: '继续前往 {provider} 前，请确认此连接授予 jcode Cloud 的账号级访问权限。',
    consentShared: '令牌会成为你的 Repositories 共用凭据，而不是安装者的个人凭据。',
    consentTasks: '你的 Repository 任务可使用每个已启用的提供方连接，包括此连接。',
    consentPersistence: '此连接会持续存在，直到被断开或由提供方撤销。',
    consentPublic: '在公开仓库中，一条 @jcode 评论可以使用已启用的提供方凭据启动任务。',
    consentAcknowledge: '我理解并同意此账号级 Repository 访问权限。',
  },
  projects: {
    noServicesConnected: '未连接服务',
    serviceCount_one: '{count} 个服务',
    serviceCount_other: '{count} 个服务',
    eyebrow: '你的工作区',
    title: '项目',
    description: '项目将交付同一产品的人员、服务、模型访问和自动化策略组织在一起。',
    newProject: '新建项目',
    loadingProjects: '加载项目…',
    loadError: '无法加载项目',
    empty: {
      eyebrow: '从边界开始',
      title: '还没有项目。',
      body: '将第一个项目创建为空容器。下一个界面让你将仓库授权为服务，而不会假装不可用的提供方已连接。',
      cta: '创建第一个项目',
    },
    listTitle: '所有项目',
    visible: '可见',
    searchProjects: '搜索项目',
    searchPlaceholder: '搜索名称或服务…',
    updatedJustNow: '刚刚更新',
    searchEmptyTitle: '没有匹配的项目。',
    searchEmptyBody: '试试项目、服务或仓库名称。',
    createdAt: '创建于 {time}',
    openWorkspace: '打开工作区',
    guide: {
      eyebrow: '项目如何运作',
      title: '让所有权保持宽泛。让执行保持明确。',
      body: '项目是长期存在的边界；每个仓库都会成为一个服务，拥有各自的模型和自动化接线。',
      step1Title: '创建边界',
      step1Desc: '为产品或团队命名。',
      step2Title: '添加服务',
      step2Desc: '显式授权仓库。',
      step3Title: '开始任务',
      step3Desc: '仅在依赖项就绪之后。',
    },
    create: {
      nameRequired: '名称为必填项。',
      created: '项目 “{name}” 已创建。',
      createFailed: '创建项目失败。',
      submit: '创建项目',
      nameLabel: '名称',
      namePlaceholder: 'demo',
      nameHint: '接下来你将在项目页面添加仓库。',
    },
    new: {
      nameRequired: '名称为必填项。',
      created: '项目已创建。',
      createFailed: '无法创建项目。',
      heading: '创建项目',
      subheading: '从所有权边界开始。服务紧随其后。',
      draft: '草稿',
      step1Eyebrow: '01 / 身份',
      section1Title: '项目详情',
      section1Body: '使用人们能够识别的产品或团队边界。',
      nameLabel: '名称',
      namePlaceholder: '例如 jcode Cloud',
      nameHint: '你可以稍后重命名项目，而无需更改服务 URL。',
      step2Eyebrow: '02 / 边界',
      section2Title: '这里包含什么',
      section2Body: '仓库会在创建后作为服务添加。',
      calloutStrong: '尚未创建或连接任何仓库。',
      calloutBody: '生成的工作区会以空白状态打开，所有者在其中显式授权每个服务。',
      submit: '创建项目',
      asideEyebrow: '创建之后',
      asideTitle: '工作区以空白状态打开。',
      asideBody: '这让项目创建保持真实：即使还没有可用的 Git 提供方或模型，容器也可以存在。',
      asideItem1: '将仓库连接为服务。',
      asideItem2: '查看 Cluster 管理员授权的模型。',
      asideItem3: '仅在所需依赖项配置完成后才开始任务。',
    },
  },

  usage: {
    title: '用量',
    disclaimer: '用量是运营遥测，不是供应商账单。',
    accountTitle: '云端模型用量',
    accountDescription: '此账号下设备产生的模型用量。',
    proxyOnly: '仅包含通过 Cloud Model Proxy 发送的请求。',
    unavailable: '不可用',
    reasonNotReported: '提供商没有报告这次请求的用量。',
    reasonNoRequests: '此时间范围内没有产生用量的请求。',
    reasonParseError: 'Cloud 无法解析提供商的用量数据。',
    input: '输入',
    output: '输出',
    cacheRead: '缓存读取',
    cacheWrite: '缓存写入',
    captured: '已捕获 {captured} / {requests}',
    captureReported: '已报告',
    captureIncomplete: '捕获不完整',
    reported: '提供商报告',
    estimated: '估算',
    uncosted: '未计价',
    details: '定价与捕获详情',
    requests: '请求数',
    reportedCapture: '完整捕获',
    partialCapture: '部分捕获',
    unavailableCapture: '不可用',
    parseErrors: '解析错误',
    pricingRevisions: '定价版本',
    none: '无',
    pricing: '定价',
    pricingTitle: '{model} 定价',
    pricingImmutable: '定价版本不可修改。需要变更时请新增一个带生效时间的版本。',
    addPricingRevision: '新增版本',
    currency: '币种',
    effectiveAt: '生效时间',
    inputRate: '输入 / 百万 token',
    outputRate: '输出 / 百万 token',
    cacheReadRate: '缓存读取 / 百万 token',
    cacheWriteRate: '缓存写入 / 百万 token',
    pricingHistory: '版本历史',
    loadingPricing: '正在加载定价…',
    pricingLoadError: '无法加载定价',
    noPricingRevisions: '还没有定价版本。除非提供商报告费用，否则用量会保持“未计价”。',
    pricingValidation: '请填写有效币种、生效时间，以及至少一个非负费率。',
    pricingCreateError: '无法创建定价版本',
    loading: '正在加载用量…',
    loadError: '无法加载用量',
    groupBy: '分组方式',
    group: { service: '仓库', automation: '自动化', model: '模型', device: '设备', grant: '授权范围' },
    range: '时间范围',
    range24h: '24 小时',
    range7: '7 天',
    range30: '30 天',
    range90: '90 天',
    windowNote: '显示 {timeZone} 时区下的 {range}。聚合采用 UTC 小时桶。',
    captureHealth: '采集健康度',
    costSources: '成本来源',
    reportedHelp: '由提供商返回，绝不与 Cloud 估算值合并。',
    estimatedHelp: '根据不可变的定价版本计算。',
    uncostedHelp: '没有适用类别费率的 token。',
    groupedUsage: '按{group}查看用量',
    noGroups: '此时间范围内没有可归属的用量。',
    category: {
      input: '输入',
      output: '输出',
      cache_read: '缓存读取',
      cache_write: '缓存写入',
    },
  },
  runDetail: {
    loadingRun: '加载运行…',
    loadRunError: '无法加载运行',
    loadingWorkspace: '加载项目工作区…',
    projectName: '项目 {id}',
    nav: {
      projects: '项目',
      repositories: '仓库',
    },
    railFooter: '项目工作区',
    repositoryWorkspace: '仓库工作区',
    breadcrumbLabel: '面包屑',
    breadcrumb: {
      tasks: '任务',
      detail: '详情',
    },
    recentTasks: '最近任务',
    serviceUnavailable: '仓库不可用',
    repositoryUnavailable: '仓库不可用',
    noChangesBadge: '无变更',
    action: {
      stop: '停止',
      retry: '重试',
      retryOtherModel: '切换模型',
      conversation: '对话',
    },
    retryModel: {
      title: '切换其他模型重试',
      description: '使用其他模型创建一次新的尝试。工作流、代码版本、权限和交付契约保持不变。',
      current: '当前模型',
      choose: '选择其他账号模型',
      unknown: '未知模型',
      confirm: '切换模型并重试',
	  originalUnavailable: '原模型已不可用。请选择其他账号模型。',
    },
    you: '你',
    reviewInProgress: '审查进行中…',
    reviewFailed: '此审查失败，因此未生成任何输出。',
    noReviewOutput: '未生成任何审查输出。',
    noEvents: '未记录任何对话事件。',
    waitingForAgent: '等待 agent…',
    streamDisconnected: '实时更新已断开。改为定期刷新。',
    reconnect: '重新连接',
    refreshError: '无法刷新最新的运行详情 — 显示最后已知状态。',
    modelLabel: '模型',
    toast: {
      permissionDecisionFailed: '无法发送权限决定。',
      messageFailed: '无法发送消息。',
      sessionResumed: '会话已恢复。',
      resumeFailed: '无法恢复会话。',
      canceled: '运行已取消。',
      cancelFailed: '取消失败。',
      retryDispatched: '重试已派发。',
      retryFailed: '重试失败。',
      sessionFinishing: '会话正在结束 — agent 正在收尾。',
      finishFailed: '无法结束会话。',
    },
    failure: {
      cloneFailed: '仓库克隆失败',
      setupFailed: '项目设置失败',
      agentError: 'Agent 错误',
      modelRateLimited: '模型触发限流',
      timeout: '已超时',
      pushFailed: '分支推送失败',
      runFailed: '运行失败',
      noMessage: '运行失败，且无消息。',
    },
    kind: {
      codeReview: '代码审查',
      session: '会话',
      automatedTask: '自动任务',
      manualTask: '手动任务',
    },
    originLabel: {
      webhook: '提供方 Webhook',
      schedule: '定时',
      kanban: 'Kanban',
      prEvent: 'PR 事件',
      manual: '手动',
    },
    session: {
      sessionQueued: '会话已排队 — 正在等待空闲并发槽位。',
      sessionStarting: '会话正在启动 — 正在调度工作区。',
      sessionActionsHint: '“结束”让 agent 在当前回合后收尾；“取消”会立即停止。',
      finishSession: '结束会话',
      resumeHint: '继续此会话 — agent 会保持相同的上下文。',
    },
    composer: {
      continuePlaceholder: '继续此任务…',
      followUpPlaceholder: '排队一条后续消息 — 它会在当前回合后运行…',
      serviceDefault: '仓库默认',
      useServiceModel: '使用仓库配置的模型',
      modelFixed: '此活动会话的模型已固定',
      messageInput: '消息输入',
      attachmentsUnavailableTitle: '附件在 Cloud 会话中尚不可用。',
      attachmentsUnavailable: '附件不可用',
      modelAccessLocked: '模型和访问权限将在你恢复时生效。',
      modeCeilingHint: 'Cloud 会话支持逐次确认、规划和自动模式。',
      queue: '排队',
      send: '发送',
      sendMessage: '发送消息',
    },
    model: {
      disabledTitle: '活动的 agent 会话会保留其现有模型。',
      chooseTitle: '为恢复的会话选择模型。',
      filterModels: '筛选模型',
      filterModelsPlaceholder: '筛选模型…',
      modelsHeading: '模型',
      noMatchingModels: '没有匹配的模型',
    },
    permission: {
      askForApproval: '请求批准',
      askForApprovalSub: 'Agent 在运行工具前询问',
      plan: '计划',
      planSub: '在 Cloud 会话中尚不可用',
      fullAccess: '完全访问',
      fullAccessSub: 'Agent 无需询问即可操作',
      permissionMode: '权限模式',
      disabledTitle: '活动的 agent 会话会保留其现有权限模式。',
      chooseTitle: '选择恢复的 agent 如何请求权限。',
    },
    inspector: {
      runDetailsLabel: '运行详情',
      identityAndSource: '身份与来源',
      requestedBy: '请求者',
      accountableTo: '责任人',
      triggeredFrom: '触发来源',
      executedFor: '执行对象',
      project: '项目',
      repository: '代码仓库',
      dispatchSnapshot: '调度时快照',
      writtenBackAs: '回写身份',
      externalActor: '外部身份',
      ruleOwner: '规则负责人',
      botOrApp: 'Bot / 应用',
      notAttributed: '无法归属',
      notApplicable: '不适用',
      technicalIdentity: '技术身份',
      runtimePrincipal: '运行主体',
      attribution: '归属精度',
      source: '来源',
      precisionExact: '精确',
      precisionLinkedExternal: '已关联外部身份',
      precisionRuleOwner: '归属到规则负责人',
      precisionUnattributed: '无法归属',
      runOverview: '运行概览',
      service: '服务',
      unavailable: '不可用',
      trigger: '触发',
      notReported: '未报告',
      permission: '权限',
      askBeforeActions: '操作前询问',
      workspace: '工作区',
      changes: '变更',
      noCodeChanges: '无代码变更',
      reviewPatch: '查看完整补丁',
      loadingChangeSummary: '加载变更摘要…',
      diffUnavailable: 'diff 不可用',
      diffAfterAgent: '在 agent 生成 diff 后可用',
      viewCompleteDiff: '查看完整 diff',
      openPrDetails: '打开拉取请求详情',
      draftPr: '草稿 PR',
      readyPr: '待评审 PR',
      pullRequest: 'Pull request',
      closedPr: '已关闭 PR',
      mergedPr: '已合并 PR',
      prDeliveryConflict: '同一分支存在多个打开的 PR，Pull request 交付已暂停。',
      prProviderUnsupported: 'Git 提供方无法可靠地把此 Pull request 转为待评审状态。',
      executionStatus: '执行状态',
      deliveryStatus: '交付状态',
      deliveryKind: '交付目标',
      deliveryIssue: '交付问题',
      deliveryUnknown: '未报告',
      delivery: { not_required: '无需交付', pending: '交付中', delivered: '已交付', failed: '交付失败' },
      deliveryKindLabel: { artifact: '产物', pull_request: '拉取请求', branch_update: '分支更新', review_comment: 'Review 评论' },
      execution: '执行',
      started: '开始',
      notStarted: '未开始',
      duration: '时长',
      runId: '运行 ID',
      retryOf: '重试自',
      resumedFrom: '恢复自',
      resumedFromLink: '恢复自 {id}',
    },
    contract: {
      title: '执行契约',
      legacyUnavailable: '此历史运行早于不可变执行契约功能。',
      workflow: '工作流',
      profile: 'Agent 配置',
      trigger: '触发器',
      model: '模型',
      timeout: '超时',
      delivery: '交付',
      verification: '校验',
      technical: '技术契约',
      hash: '契约哈希',
      definition: '定义',
      access: '工作区',
      requirements: '能力要求',
    },
    coverage: {
      eyebrow: '评审输入',
      title: '评审覆盖范围',
      unavailable: '不可用',
      legacyUnavailable: '此历史评审运行未记录覆盖范围。',
      complete: '完整',
      partial: '部分',
      files: '已索引文件',
      hunks: '已索引代码块',
      lines: '变更行',
      baseHead: '基线 → 提交',
      mergeBase: '共同祖先',
      skipped: '跳过 {count} 个文件',
      indexed: '覆盖 {count} 个文件',
      ledger: '覆盖台账',
      fileStats: '{hunks} 个代码块 · {lines} 行',
      noneSkipped: '没有跳过文件。',
      noneIndexed: '没有已索引文件。',
      unsupported: '不支持',
    },
    review: {
      titleFallback: 'Pull request 评审 #{number}',
      pullRequest: 'Pull request',
      base: '基线',
      head: '提交',
      revisions: '冻结版本',
      delivery: {
        running: '评审中',
        posting: '正在回传评审',
        posted: '已发布',
        incomplete: '回传未完成',
        unavailable: '结果不可用',
        error: '回传重试中',
      },
      deliveryError: {
        title: '提供方回传需要关注',
      },
      stage: {
        planTitle: '正在准备确定性评审计划',
        planBody: '冻结准确的基线与提交版本，并索引所有变更行。',
        analysisTitle: '正在分析已索引变更',
        analysisBody: '系统正依据已接受的覆盖计划检查高置信度缺陷。',
        activity: 'Runner 活动',
      },
      legacy: {
        title: '结构化评审结果不可用',
        body: '此终态运行早于结构化评审契约，或未产生有效结果。旧的提供方 Markdown 不再被渲染成 Cloud 状态。',
      },
      result: {
        eyebrow: '已校验输出',
        title: '评审发现',
        count: '{count} 个发现',
        noFindings: '已索引变更中没有发现高置信度缺陷。',
        incompleteTitle: '评审未完整完成',
        incompleteBody: '本次评审没有得出可视为通过的结论。已确认的问题仍会保留，但零发现不代表此 PR 没有问题。',
        confidence: '置信度 {confidence}%',
        suggestion: '建议修改',
        checks: '{count} 项校验记录',
      },
      grant: {
        title: '冻结 SCM 授权',
        provider: '提供方',
        repository: '仓库',
        installation: '安装',
        config: '提供方配置',
        credential: '凭据版本',
        principal: '执行身份',
        unavailable: '仓库授权尚未冻结，或此历史运行没有可用记录。',
      },
    },
    origin: {
      fromPrComment: '来自 PR 评论',
      scheduled: '定时',
      kanbanAutomation: 'Kanban 自动化',
      prEventAutomation: 'PR 事件自动化',
    },
    diff: {
      runFailedNoDiff: '此运行失败，因此未生成 diff。',
      diffAfterArtifact: 'diff 将在 agent 生成产物后可用。',
      noCodeChanges: '此运行未做任何代码变更。',
      loadingDiff: '加载 diff…',
      loadDiffError: '无法加载 diff',
    },
    failedSubmission: {
      notSent: '消息未发送。',
      draftPreserved: '你的草稿已保留。',
      retryUnsent: '重试未发送的消息',
    },
  },
};
